// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/assets/images/images/home-hero-bg-mobile.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Qwitcher+Grypen&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --hero-font: 3vw;
  --section-heading-font: 2vw;
}

* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  font-family: "Manrope", sans-serif;
}

body {
  height: 100vh;
  width: 100%;
  font-family: "Manrope", sans-serif;
}

/* sign in style */
.signin {
  width: 100%;
  height: 100%;
  /* display: flex; */
}
.signin__leftimg {
  /* width: 40%; */
  /* width: 35%;
  min-width: 500px;
  height: 100%;
  position: relative; */
}
.signin__leftimg__img {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  z-index: 1;
  object-fit: cover;
}
.signin__leftimg__img-cover {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  z-index: 99;
  object-fit: cover;
}
.signin__leftimg__textcontainer {
  position: absolute;
  z-index: 100;
  bottom: 23%;
  color: #ffffff;
  width: 100%;
  padding: 0 4vw;
  display: flex;
  flex-direction: column;
  gap: 2vw;
}
.signin__leftimg__textcontainer div {
  line-height: 35.5px;
}
.signin__leftimg__textcontainer__heading {
  font-size: 2.3vw;
  font-weight: bolder;
}
.signin__leftimg__textcontainer__content {
  font-size: 1.05vw;
  font-weight: normal;
}
.signin__right {
  display: flex;
  /* width: 60%; */
  /* width: 75%;
  height: 100%;
  flex-direction: column; */
  /* gap: 10vmin; */
  /* padding: 2.2vw 4vw; */
  overflow: hidden;
}
.signin__right__top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.signin__right__top__btn {
  text-decoration: none;
  background-color: #eff1f4;
  color: #cd1479;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  gap: 0.75vw;
  align-items: center;
  padding: 9px 12px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}
.signin__right__top__rightcontent {
  font-size: 14px;
}
.signin__right__top__rightcontent a {
  text-decoration: none;
  color: #cd1479;
  font-weight: 500;
}
.signin__right__form {
  width: 40%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 4vmin;
}
.signin__right__form__topcontent {
  display: flex;
  flex-direction: column;
  gap: 1px;
}
.signin__right__form__topcontent div:nth-child(1) {
  font-size: 24px;
  font-weight: 700;
  color: #150648;
}
.signin__right__form__topcontent div:nth-child(2) {
  font-weight: normal;
  font-size: 14px;
  color: #667085;
}
.signin__right__form__topcontent div:nth-child(3) {
  margin-top: 5px;
  width: 48px;
  height: 8px;
  background-color: #007364;
}
.signin__right__form__logingooglebtn {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.signin__right__form__logingooglebtn__btn {
  cursor: pointer;
  max-width: 100%;
  min-width: 100%;
  padding: 8px 16px;
  border: 1px solid #9999b9;
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
}
.signin__right__form__logingooglebtn__btn div:nth-child(2) {
  color: #03014c;
  font-size: 16px;
}
.signin__right__form__logingooglebtn__btn div:last-child {
  visibility: hidden;
}
.signin__right__form__logingooglebtn__content {
  font-size: 14px;
  font-weight: 500;
}
.signin__right__form__input-fields {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
}
.signin__right__form__input-fields__input-item {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.signin__right__form__input-fields__input-item__labeldiv {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.signin__right__form__input-fields__input-item__labeldiv div:nth-child(1) {
  font-size: 14px;
  color: #150648;
  font-weight: 500;
}
.signin__right__form__input-fields__input-item__labeldiv div:nth-child(2) {
  font-size: 13px;
  color: #667085;
}
.signin__right__form__input-fields__input-item label {
  font-size: 14px;
  color: #150648;
  font-weight: 500;
}
.signin__right__form__input-fields__input-item input {
  width: 100%;
  background-color: #ffffff;
  border: 1px solid #9999b9;
  padding: 8px 16px;
}
.signin__right__form__input-fields__input-item input ::placeholder {
  color: #667085;
}
.signin__right__form__input-fields__input-item input:focus {
  outline: none;
}
.signin__right__form__input-fields__input-item-password {
  position: relative;
}
.signin__right__form__input-fields__input-item-password-input {
  padding-right: 30px;
}
.signin__right__form__input-fields__input-item-password-icon {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}
.signin__right__form__signinbtn {
  width: 100%;
  padding-top: 10px;
}
.signin__right__form__signinbtn button {
  text-align: center;
  width: 100%;
  background-color: #dd4498;
  color: #ffffff;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  padding: 12px 0;
}
.signin__bottom {
  display: flex;
  color: #667085;
  justify-content: flex-end;
  padding-top: 4vh;
}
/* sign in style */

/* sign up style */
.signup {
  width: 100%;
  height: 100%;
  display: flex;
}
.signup__leftimg {
  width: 35%;
  min-width: 500px;
  height: 100%;
  position: relative;
}
.signup__leftimg__img {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  z-index: 1;
  object-fit: cover;
}
.signup__leftimg__img-cover {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  z-index: 99;
  object-fit: cover;
}
.signup__leftimg__textcontainer {
  position: absolute;
  z-index: 100;
  bottom: 23%;
  color: #ffffff;
  width: 100%;
  padding: 0 4vw;
  display: flex;
  flex-direction: column;
  gap: 2vw;
}
.signup__leftimg__textcontainer div {
  line-height: 35.5px;
}
.signup__leftimg__textcontainer__heading {
  font-size: 2.3vw;
  font-weight: bolder;
}
.signup__leftimg__textcontainer__content {
  font-size: 1.05vw;
  font-weight: normal;
}
.signup__right {
  width: 75%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 10vmin;
  padding: 2.2vw 4vw;
  overflow: hidden;
}
.signup__right__top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.signup__right__top__btn {
  text-decoration: none;
  background-color: #eff1f4;
  color: #cd1479;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  gap: 0.75vw;
  align-items: center;
  padding: 9px 12px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}
.signup__right__top__rightcontent {
  font-size: 14px;
}
.signup__right__top__rightcontent a {
  text-decoration: none;
  color: #cd1479;
  font-weight: 500;
}
.signup__right__form {
  width: 40%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 2.2vmin;
}
.signup__right__form__topcontent {
  display: flex;
  flex-direction: column;
  gap: 1px;
}
.signup__right__form__topcontent div:nth-child(1) {
  font-size: 24px;
  font-weight: 700;
  color: #150648;
}
.signup__right__form__topcontent div:nth-child(2) {
  font-weight: normal;
  font-size: 14px;
  color: #667085;
}
.signup__right__form__topcontent div:nth-child(3) {
  margin-top: 5px;
  width: 48px;
  height: 8px;
  background-color: #007364;
}
.signup__right__form__logingooglebtn {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.signup__right__form__logingooglebtn__btn {
  cursor: pointer;
  max-width: 100%;
  min-width: 100%;
  padding: 10px 16px;
  border: 1px solid #9999b9;
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
}
.signup__right__form__logingooglebtn__btn div:nth-child(2) {
  color: #03014c;
  font-size: 16px;
}
.signup__right__form__logingooglebtn__btn div:last-child {
  visibility: hidden;
}
.signup__right__form__logingooglebtn__content {
  font-size: 14px;
  font-weight: 500;
}
.signup__right__form__input-fields {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  width: 100%;
}
.signup__right__form__input-fields__input-item {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.signup__right__form__input-fields__input-item label {
  font-size: 14px;
  color: #150648;
  font-weight: 500;
}
.signup__right__form__input-fields__input-item input {
  width: 100%;
  background-color: #ffffff;
  border: 1px solid #9999b9;
  padding: 10px 16px;
}
.signup__right__form__input-fields__input-item input ::placeholder {
  color: #667085;
}
.signup__right__form__input-fields__input-item input:focus {
  outline: none;
}
.signup__right__form__signupbtn {
  width: 100%;
  padding-top: 10px;
}
.signup__right__form__signupbtn button {
  text-align: center;
  width: 100%;
  background-color: #dd4498;
  color: #ffffff;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  padding: 12px 0;
}

.password-field {
  position: relative;
}

.password-input-container {
  position: relative;
}

.password-input {
  width: 100%;
  background-color: #ffffff;
  border: 1px solid #9999b9;
  padding: 10px 16px;
}
.password-input ::placeholder {
  color: #667085;
}
.password-input:focus {
  outline: none;
}

.password-icon {
  position: absolute;
  top: 70%;
  right: 10px;
  transform: translateY(-50%);
}
/* sign up style */

/* navbar Style */
.header__navbar {
  width: 100%;
  background-color: #ffffff;
  height: 10vh;
  position: sticky;
  top: 0;
  z-index: 999;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.1);
}

.webbie_container {
  width: 95%;
  height: 100%;
  margin: 0 auto;
  padding: 1vh 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header_logo img {
  width: 180px;
}
.webbie_container_container__navitems {
  display: flex;
  gap: 2vw;
  list-style: none;
  align-items: center;
}
.webbie_container_container__navitems li a {
  cursor: pointer;
  color: #000000;
  font-size: 1vw;
  font-weight: 700;
  text-decoration: none;
}
.homepage__navbar__container__navitems_login {
  display: flex;
  gap: 2vw;
  align-items: center;
}
.homepage__navbar__container__navitems_login div a {
  cursor: pointer;
  font-weight: 500;
  color: #000000;
  font-size: 1vw;
  font-weight: 700;
  text-decoration: none;
}
.homepage__navbar__container__navitems_login div:nth-child(2) {
  background-color: #dd4498;
  padding: 0.65vw 1vw;
  border-radius: 0.5vw;
  cursor: pointer;
}
.homepage__navbar__container__navitems_login div:nth-child(2) a {
  cursor: pointer;
  color: #ffffff;
  font-weight: 500;
}
.homepage__navbar__hamburger {
  display: none;
}
.homepage__navbar__hamburger-menu {
  display: none;
  z-index: 999;
  border-top: 2px solid #688ad5 !important;
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #ffffff;
  width: 100%;
  padding: 1rem;
  border: 1px solid #ddd;
  border-top: none;
}
.homepage__navbar__hamburger-menu.show {
  display: block;
}
.homepage__navbar__hamburger-menu ul {
  list-style: none;
  padding: 0;
}
.homepage__navbar__hamburger-menu ul li {
  margin-bottom: 1rem;
}
.homepage__navbar__hamburger-menu ul li a {
  color: #000000;
  text-decoration: none;
  font-size: 1rem;
  font-weight: 500;
}

/* Homepage Style */
.homepage {
  width: 100%;
}
.hero {
  width: 100%;
  height: 60vh;
}
.hero__herosection {
  width: 100%;
  height: 100%;
  position: relative;
}
.hero__herosection__img1 {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  object-fit: cover;
}
.hero__herosection__img2 {
  position: absolute;
  z-index: 2;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  object-fit: cover;
}
.hero__content {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 99;
}
.hero__content__div {
  height: 100%;
  width: 80%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.hero__content__div__text {
  width: 45%;
  height: 50%;
  margin: auto 0;
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
  gap: 1rem;
}

.hero__content__div__text__heading {
  color: #ffffff;
  font-size: var(--hero-font);
  font-weight: bolder;
}
.hero__content__div__text__content {
  font-size: 1.1vw;
  color: #ffffff;
  font-weight: 500;
  width: 100%;
}
.hero__content__div__text__button {
  padding-top: 3vh;
}
.hero__content__div__text__button a {
  cursor: pointer;
  border: none;
  border-radius: 6px;
  font-size: 1vw;
  padding: 0.75vw 1vw;
  color: #000000;
  background-color: #f3f2f2;
  text-decoration: none;
}
.hero__content__div__image {
  width: 40%;
}
.hero__content__div__image img {
  width: 100%;
}
.homepage__bussinessbox {
  width: 100%;
}
.homepage__bussinessbox__container {
  width: 80%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 1vw;
  padding: 3vmin 0;
}
.homepage__bussinessbox__container__img1,
.homepage__bussinessbox__container__img2,
.homepage__bussinessbox__container__img3 {
  width: 25%;
}
.homepage__bussinessbox__container__img1__div,
.homepage__bussinessbox__container__img2__div,
.homepage__bussinessbox__container__img3__div {
  width: 80%;
  display: flex;
  flex-direction: column;
  gap: 0.75vw;
  justify-content: center;
}
.homepage__bussinessbox__container__img1__div img,
.homepage__bussinessbox__container__img2__div img,
.homepage__bussinessbox__container__img3__div img {
  width: 100%;
  object-fit: cover;
}
.homepage__bussinessbox__container__img1__div div,
.homepage__bussinessbox__container__img2__div div,
.homepage__bussinessbox__container__img3__div div {
  text-align: center;
  font-size: 1.5vw;
  font-weight: 800;
  color: #001d7d;
}
.homepage__bussinessbox__container__plus,
.homepage__bussinessbox__container__equal {
  width: 3%;
  font-family: "Qwitcher Grypen", cursive;
  font-size: 6vw;
  color: #001d7d;
}

.homepage__bussinessbox__container__text {
  width: 17%;
  height: 100%;
  padding-left: 1vw;
}
.homepage__bussinessbox__container__text span {
  font-size: 32px;
  color: #001d7d;
  font-weight: 900;
}
.homepage__bsimplified {
  width: 100%;
  background-color: #f8fafc;
}
.homepage__bsimplified__container {
  width: 80%;
  margin: 0 auto;
  padding: 4vmax 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.homepage__bsimplified__container__content {
  width: 40%;
  display: flex;
  flex-direction: column;
  gap: 3vh;
}
.homepage__bsimplified__container__content__heading {
  font-size: var(--section-heading-font);
  font-weight: bolder;
  color: #000000;
}
.homepage__bsimplified__container__content__list {
  display: flex;
  flex-direction: column;
  gap: 2vh;
}
.homepage__bsimplified__container__content__list li {
  display: flex;
  align-items: center;
  gap: 1vw;
}
.homepage__bsimplified__container__content__list li span {
  font-size: 1.1vw;
  color: #625d5d;
}
.homepage__bsimplified__container__content__signupbtn {
  display: flex;
  align-items: center;
  padding: 0.5vw 0;
}
.homepage__bsimplified__container__content__signupbtn a {
  display: flex;
  align-items: center;
  gap: 0.75vw;
  text-decoration: none;
  height: 100%;
  padding: 10px 20px;
  border: 1px solid #688ad5;
  border-radius: 6px;
}
.homepage__bsimplified__container__content__signupbtn a span {
  text-decoration: none;
  font-size: 1.1vw;
  color: #688ad5;
}
.homepage__bsimplified__container__content__signupbtn a span img {
  object-fit: cover;
}
.homepage__bsimplified__right {
  width: 50%;
}
.homepage__bsimplified__right img {
  width: 100%;
}
.homepage__bottomPart {
  width: 100%;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 4vmax;
  height: 75vh;
  padding: 5vh 0;
}
.homepage__bottomPart__businessgrow {
  width: 80%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  position: relative;
  height: 90%;
}
.homepage__bottomPart__businessgrow__image {
  height: 100%;
  width: 35%;
  position: absolute;
  top: 0;
  z-index: 1;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 10px;
  border-radius: 8px;
}
.homepage__bottomPart__businessgrow__image img {
  object-fit: cover;
  width: 100%;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.homepage__bottomPart__businessgrow__image__topcontent {
  position: absolute;
  top: 10%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 15px;
  z-index: 3;
}
.homepage__bottomPart__businessgrow__image__topcontent div {
  text-align: center;
  width: 100%;
}
.homepage__bottomPart__businessgrow__image__topcontent div:nth-child(1) {
  width: 100%;
  display: flex;
  justify-content: center;
}
.homepage__bottomPart__businessgrow__image__topcontent div:nth-child(1) img {
  width: 40px;
  object-fit: cover;
}
.homepage__bottomPart__businessgrow__image__topcontent div:nth-child(2) {
  width: 80%;
  margin: 0 auto;
}
.homepage__bottomPart__businessgrow__image__topcontent div:nth-child(2) img {
  width: 70%;
}
.homepage__bottomPart__businessgrow__image__topcontent div:nth-child(3) {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.homepage__bottomPart__businessgrow__image__topcontent
  div:nth-child(3)
  span:nth-child(1) {
  text-shadow: 1px 0 #000000;
  letter-spacing: 1px;
  color: #000000;
  font-size: var(--section-heading-font);
  font-weight: 900;
}
.homepage__bottomPart__businessgrow__image__topcontent
  div:nth-child(3)
  span:nth-child(2) {
  color: #000000;
  font-size: 1.2vw;
  font-weight: 700;
}
.homepage__bottomPart__businessgrow__image__topcontent div:nth-child(4) button {
  border: none;
  background-color: #ee3572;
  color: #ffffff;
  font-size: 1.35vw;
  font-weight: 700;
  padding: 0.75vw 2vw;
  border-radius: 5px;
  cursor: pointer;
}
.homepage__bottomPart__businessgrow__image__topcontent div:nth-child(5) {
  width: 80%;
  margin: 0 auto;
}
.homepage__bottomPart__businessgrow__image__topcontent div:nth-child(5) p {
  font-size: 1vw;
  padding: 1vw;
  color: #7d7878;
  border: 1.5px dashed #7d7878;
}
.homepage__bottomPart__businessgrow__right {
  width: 40%;
  position: absolute;
  right: 0;
  display: flex;
  flex-direction: column;
  gap: 10%;
  height: 100%;
  justify-content: center;
}
.homepage__bottomPart__businessgrow__right__content {
  display: flex;
  flex-direction: column;
}
.homepage__bottomPart__businessgrow__right__content {
  font-size: var(--section-heading-font);
  font-weight: 900;
}
.homepage__partners {
  width: 100%;
  background-color: #ffffff;
  gap: 2vh;
  padding: 4vmin 0;
}
.homepage__partners__div {
  width: 80%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 3vmax;
}
.homepage__partners__div__head {
  display: flex;
  gap: 5%;
  align-items: center;
}
.homepage__partners__div__head span:nth-child(1),
.homepage__partners__div__head span:nth-child(3) {
  height: 2px;
  background-color: #000000;
  width: 27%;
}
.homepage__partners__div__head span:nth-child(2) {
  font-size: 2vw;
  font-weight: 600;
  color: #000000;
}
.homepage__partners__div__brandlogos {
  display: flex;
  align-items: center;
  /* gap: 10%; */
}
.homepage__partners__div__brandlogos__c1 {
  width: 50%;
  display: flex;
  gap: 15%;
  align-items: center;
}

.homepage__support {
  width: 100%;
  background-color: #ffffff;
}
.homepage__support__div {
  width: 80%;
  height: 90%;
  margin: 0 auto;
  padding: 3vmax 0;
  display: flex;
  justify-content: space-between;
}
.homepage__support__div__card {
  display: flex;
  flex-direction: column;
  gap: 2vmax;
  width: 28%;
  padding: 2vw;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 10px;
}
.homepage__support__div__card__image {
  position: relative;
  z-index: 1;
}
.homepage__support__div__card__image .roundshape {
  left: 0;
  height: 35px;
  width: 35px;
  background-color: rgba(204, 55, 144, 0.2666666667);
  border-radius: 50%;
  position: absolute;
  z-index: 99;
  top: 31px;
  left: -6px;
}
.homepage__support__div__card__image img {
  height: 60px;
  width: 60px;
}
.homepage__support__div__card__content {
  display: flex;
  flex-direction: column;
  gap: 0.5vw;
}
.homepage__support__div__card__content div:nth-child(1) {
  font-size: 1vw;
  font-weight: 700;
  color: #1e1d1d;
}
.homepage__support__div__card__content div:nth-child(2) {
  font-size: 1vw;
  font-weight: 500;
  color: #625d5d;
}
.homepage__support__div__card__nextbtn {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.homepage__support__div__card__nextbtn__imgdiv {
  padding: 0 2.25vw;
  background-color: #ffffff;
  color: #688ad5;
  font-size: 1.25vw;
  border: 2px solid #688ad5;
  border-radius: 2vw;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
/* homepage style */

/* about style */
.aboutpage {
  width: 100%;
}
.aboutpage__container {
  width: 80%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 3vh;
  position: relative;
  z-index: 1;
}
.aboutpage__container__div {
  width: 100%;
  margin: 0 auto;
  padding: 2vmin 0;
}
.aboutpage__container__div__para {
  display: flex;
  flex-direction: column;
  gap: 3vmin;
  padding: 2vmin 0;
}
.aboutpage__container__div__para p {
  text-align: justify;
  font-size: 16px;
  font-weight: 500;
}
.aboutpage__container__trustdiv {
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.aboutpage__container__trustdiv__left {
  width: 55%;
  background-color: #688ad5;
  padding: 2.5vw 2vw;
  display: flex;
  flex-direction: column;
  gap: 2vmax;
  border-radius: 1vw;
}
.aboutpage__container__trustdiv__left__title {
  font-size: var(--section-heading-font);
  font-weight: 900;
  display: flex;
  color: #ffffff;
  flex-direction: column;
  align-items: center;
}
.aboutpage__container__trustdiv__left__images {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2vmax;
}
.aboutpage__container__trustdiv__left__images__top {
  display: flex;
  width: 100%;
  gap: 2.5vw;
  align-items: center;
  justify-content: center;
}
.aboutpage__container__trustdiv__left__images__top div {
  width: 30%;
}
.aboutpage__container__trustdiv__left__images__top div img {
  width: 100%;
  object-fit: scale-down;
}
.aboutpage__container__trustdiv__right {
  border-radius: 1vw;
  width: 40%;
  padding: 2.5vw 2vw;
  background-color: #dd4498;
  display: flex;
  flex-direction: column;
  gap: 2.5vmax;
  align-items: center;
}
.aboutpage__container__trustdiv__right__nextbtn {
  width: 100%;
}
.aboutpage__container__trustdiv__right__nextbtn__imgdiv {
  width: 35px;
  height: 35px;
  background-color: #ffffff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 1.75vw;
}
.aboutpage__container__trustdiv__right div {
  font-size: var(--section-heading-font);
  font-weight: 900;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.aboutpage__container__welcomediv {
  width: 80%;
  margin: 0 auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 2vmax;
  padding: 4vmax 0;
}
.aboutpage__container__welcomediv div:nth-child(1) {
  font-size: var(--section-heading-font);
  font-weight: 900;
}
.aboutpage__container__welcomediv div:nth-child(2) {
  display: flex;
  justify-content: space-evenly;
}
.aboutpage__container__welcomediv div:nth-child(2) div {
  padding: 15px 0px;
  font-size: 16px;
  width: 30%;
  background-color: #f1ebff;
  font-weight: 700;
  border-radius: 10px;
}
.aboutpage__container__support {
  width: 80%;
  height: 90%;
  margin: 0 auto;
  background-color: #ffffff;
  padding: 0 0 2vw 0;
}
/* about style */

/* contact style */

.contactuspage {
  width: 100%;
}
.contactuspage__container {
  width: 80%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 3vh;
  position: relative;
  z-index: 1;
}
.contactuspage__container__div {
  width: 100%;
  margin: 0 auto;
  padding: 2vmin 0;
}
.contactuspage__container__div__para__form {
  width: 100%;
  background-color: #ffffff;
}

.contactuspage__container__div__para__form__container {
  width: 70%;
  margin: 0 auto;
}

.contactuspage__container__div__para__form__container .heading {
  color: #000000;
  font-size: var(--section-heading-font);
  font-weight: 500;
  padding: 1vw 0;
  text-align: center;
}

.contact__form {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2vw;
}

.contact__form__inputfield {
  width: 80%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 0 auto;
}

.contact__form__label {
  color: #7369ab;
  font-size: 1vw;
}
.contact__form__inputfield input,
select {
  display: block;
  border: 1px solid #e5e9f5;
  background-color: #f6f7fa;
  padding: 1vw 1.5vw;
  width: 100%;
}
.contact__form__inputfield select {
  font-size: 12px;
}

.contact__form__inputfield input::placeholder {
  font-size: 1vw;
}

.contact__form__contactemail {
  display: flex;
  width: 80%;
  margin: 0 auto;
  justify-content: space-between;
}

.contact__form__contactemail div {
  width: 48%;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.contact__form__contactemail div input {
  display: block;
  border: 1px solid #e5e9f5;
  background-color: #f6f7fa;
  padding: 1vw 1.5vw;
  width: 100%;
}

.contact__form__contactemail div input::placeholder {
  font-size: 12px;
}

#contact__form__inputfield__button {
  width: 100%;
}
.contact__form__button__submit {
  margin-left: 10%;
  margin-top: 5px;
  padding: 0.65vw 2vw;
  background-color: #dd4498;
  border-radius: 5px;
  color: white;
  font-size: 1.25vw;
  border: none;
}

.contactuspage__container__welcomediv {
  width: 100%;
  margin: 0 auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 2vmax;
  padding: 1vmax 0;
}
.contactuspage__container__welcomediv__title {
  font-size: var(--section-heading-font);
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.contactuspage__container__welcomediv__title span:nth-child(1),
.contactuspage__container__welcomediv__title span:nth-child(3) {
  width: 30%;
  height: 1px;
  background: #000;
}
.contactuspage__container__welcomediv__div1,
.contactuspage__container__welcomediv__div2 {
  display: flex;
  justify-content: space-evenly;
}
.contactuspage__container__welcomediv__div1 div,
.contactuspage__container__welcomediv__div2 div {
  padding: 15px 0px;
  font-size: 16px;
  width: 30%;
  background-color: #f1ebff;
  font-weight: 700;
  border-radius: 10px;
}

/* contact style */

/* payments style */

.payments__container {
  width: 80%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 3vh;
}
.payments__container__toppart {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2.5vmax 0;
}
.payments__container__toppart__heading {
  font-size: var(--section-heading-font);
  font-weight: 500;
  letter-spacing: 1px;
  padding-bottom: 2vmax;
  margin-bottom: 3vw;
}
.payments__container__toppart__box {
  display: flex;
  flex-direction: column;
  gap: 6vmax;
  width: 100%;
}
.payments__container__toppart__box__content {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
}
.payments__container__toppart__box__content__div {
  width: 40%;
  height: 20vh;
  min-height: 200px;
  position: relative;
}
.payments__container__toppart__box__content__div .bg {
  width: 100%;
  height: 35vh;
  min-height: 200px;
  position: absolute;
  z-index: 1;
  background: #ebedf0;
  top: -16%;
  right: 6%;
  border-radius: 1vw;
}
.payments__container__toppart__box__content__div__wrapper {
  position: absolute;
  padding: 2vw;
  width: 100%;
  height: 100%;
  min-height: 200px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 10px;
  display: flex;
  flex-direction: column;
  gap: 1vh;
  z-index: 99;
  background-color: #ffffff;
  border-radius: 1vw;
}
.payments__container__toppart__box__content__div__wrapper .heading {
  font-size: 16px;
  font-weight: 700;
}
.payments__container__toppart__box__content__div__wrapper .text {
  padding-top: 20px;
  font-size: 14px;
}
.payments__container__partners {
  width: 100%;
  background-color: #ffffff;
  gap: 2vh;
  padding: 4vmin 0;
}
.payments__container__partners__div {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 3vmax;
}
.payments__container__partners__div__button {
  width: 100%;
  text-align: center;
}
.payments__container__partners__div__button a {
  font-size: 1.25vw;
  color: #ffffff;
  text-decoration: none;
  background-color: #dd4498;
  padding: 1vw 2vw;
  border-radius: 0.5vw;
  cursor: pointer;
  border: none;
}
.payments__container__partners__div__head {
  display: flex;
  gap: 5%;
  align-items: center;
}
.payments__container__partners__div__head span:nth-child(1),
.payments__container__partners__div__head span:nth-child(3) {
  height: 2px;
  background-color: #000000;
  width: 27%;
}
.payments__container__partners__div__head span:nth-child(2) {
  font-size: var(--section-heading-font);
  font-weight: 600;
  color: #000000;
}
.payments__container__partners__div__brandlogos {
  display: flex;
  gap: 10%;
  align-items: center;
}
.payments__container__partners__div__brandlogos div img {
  width: 100%;
  object-fit: cover;
}
/* payments style */

/* partners style */

.partnerspage {
  width: 100%;
}
.partnerspage__hero {
  width: 100%;
  height: 60vh;
}
.partnerspage__hero__herosection {
  width: 100%;
  height: 100%;
  /* background: url("../images/homebanner-bg-1.svg"); */
}
.partnerspage__hero__content {
  width: 100%;
  height: 100%;
}
.partnerspage__hero__content__div {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.partnerspage__hero__content__div__left {
  width: 50%;
  height: 100%;
  margin: auto 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2vmax;
  /* background: url("../images/partners-hero-right-bg.svg"); */
}
.partnerspage__hero__content__div__left__text {
  padding-left: 20%;
}
.partnerspage__hero__content__div__left__text__heading {
  color: #ffffff;
  font-size: var(--hero-font);
  font-weight: 1000;
}
.partnerspage__hero__content__div__left__text__content {
  color: #ffffff;
  width: 70%;
  display: flex;
  flex-direction: column;
  gap: 0.5vw;
}
.partnerspage__hero__content__div__left__text__content__top {
  font-size: 1.1vw;
  font-weight: 700;
}
.partnerspage__hero__content__div__left__text__button {
  padding-top: 2vh;
}
.partnerspage__hero__content__div__left__text__button a {
  cursor: pointer;
  border: none;
  border-radius: 5px;
  font-size: 1vw;
  padding: 0.75vw 1vw;
  text-decoration: none;
  color: #000000;
  background-color: #f3f2f2;
}
.partnerspage__hero__content__div__image {
  width: 50%;
  height: 100%;
}
.partnerspage__hero__content__div__image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.partnerspage__container {
  width: 80%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 3vh;
  position: relative;
  z-index: 1;
}
.partnerspage__container__div {
  width: 100%;
  margin: 0 auto;
  padding: 2vmin 0;
}
.partnerspage__container__div__para {
  display: flex;
  padding: 2vmin 0;
  justify-content: space-between;
  align-items: center;
}
.partnerspage__container__div__para__equal {
  width: 3%;
  font-family: "Qwitcher Grypen", cursive;
  font-size: 7vw;
  color: #001d7d;
}
.partnerspage__container__div__para__box {
  width: 28%;
}
.partnerspage__container__div__para__box img {
  width: 100%;
  object-fit: cover;
}

.partnerspage__container__welcomediv {
  width: 100%;
  margin: 0 auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 2vmax;
  padding: 1vmax 0;
}
.partnerspage__container__welcomediv__title {
  font-size: var(--section-heading-font);
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.partnerspage__container__welcomediv__title span:nth-child(1),
.partnerspage__container__welcomediv__title span:nth-child(3) {
  width: 30%;
  height: 1px;
  background: #000;
}
.partnerspage__container__welcomediv__div1,
.partnerspage__container__welcomediv__div2 {
  display: flex;
  justify-content: space-evenly;
}
.partnerspage__container__welcomediv__div1 div,
.partnerspage__container__welcomediv__div2 div {
  padding: 12px 0px;
  font-size: 20px;
  width: 30%;
  background-color: #f1ebff;
  font-weight: 600;
  border-radius: 6px;
}

/* partners style */

/* shipping style  */
.shipping {
  width: 100%;
}
.shipping__container {
  width: 80%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 3vh;
}
.shipping__container__toppart {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2.5vmax 0;
}
.shipping__container__toppart__heading {
  font-size: var(--section-heading-font);
  font-weight: 500;
  letter-spacing: 1px;
  padding-bottom: 2vmax;
  margin-bottom: 3vw;
}
.shipping__container__toppart__box {
  display: flex;
  flex-direction: column;
  gap: 3vmax;
  width: 100%;
}
.shipping__container__toppart__box__content {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
}
.shipping__container__toppart__box__content__div {
  width: 30%;
  height: 30vh;
  min-height: 280px;
  position: relative;
}
.shipping__container__toppart__box__content__div .bg {
  width: 100%;
  height: 30vh;
  min-height: 280px;
  position: absolute;
  z-index: 1;
  background: #ebedf0;
  top: 8%;
  right: -4%;
  border-radius: 1vw;
}
.shipping__container__toppart__box__content__div__wrapper {
  position: absolute;
  padding: 2vw;
  width: 100%;
  height: 100%;
  min-height: 280px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 10px;
  display: flex;
  flex-direction: column;
  gap: 1vh;
  z-index: 99;
  background-color: #ffffff;
  border-radius: 1vw;
}
.shipping__container__toppart__box__content__div__wrapper .heading {
  font-size: 16px;
  font-weight: 700;
  min-height: 40px;
}
.shipping__container__toppart__box__content__div__wrapper .text {
  font-size: 14px;
}

/* shipping style */

/* footer Style */

.footer {
  width: 100%;
  background: #1e1d1d;
}
.footer__div {
  width: 80%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  padding: 1vw 0;
}
.footer__div__top {
  display: flex;
  justify-content: space-between;
  padding: 2vw 0;
}
.footer__div__top__aboutus {
  width: 30%;
  display: flex;
  flex-direction: column;
  gap: 1vw;
  color: #ffffff;
}
.footer__div__top__aboutus div:nth-child(1) {
  font-size: 1vw;
  font-weight: bolder;
}
.footer__div__top__aboutus div:nth-child(2) {
  font-size: 1vw;
  font-weight: 300;
}
.footer__div__top__aboutus div:nth-child(3) {
  font-size: 1.25vw;
  display: flex;
  gap: 12px;
}
.footer__div__top__aboutus div:nth-child(3) a {
  color: #ffffff;
}
.footer__div__top__right {
  width: 30%;
  display: flex;
  justify-content: space-between;
  padding-left: 60px;
}
.footer__div__top__right__notifications {
  width: 70%;
  display: flex;
  list-style: none;
  flex-direction: column;
  gap: 3px;
  font-size: 1vw;
  color: #ffffff;
  font-weight: bolder;
}

.footer__div__top__right__notifications__heading {
  border-bottom: 1px solid white;
  width: -moz-fit-content;
  width: fit-content;
  margin-bottom: 3px;
}

.footer__div__top__right__notifications li a {
  font-size: 12px;
  text-decoration: none;
  color: #ffffff;
  font-weight: 500;
}
.footer__div__top__right__form {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  align-content: flex-end;
}
.footer__div__top__right__form input {
  width: 100%;
  padding: 0.75vw 0.75vw;
  border-radius: 0.5vw;
  border: none;
}
.footer__div__top__right__form input :focus {
  outline: none;
}
.footer__div__top__right__form button {
  width: 100%;
  background-color: #dd4498;
  color: #ffffff;
  font-size: 1.25vw;
  padding: 0.5vw 0;
  border-radius: 0.5vw;
  cursor: pointer;
  border: none;
}
.footer__div__bottom {
  width: 80%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  padding: 30px 0px;
}
.footer__div__bottom__left {
  display: flex;
  gap: 1vw;
}
.footer__div__bottom__left span {
  color: #ffffff;
  font-size: 1vw;
}
.footer__div__bottom__left span a {
  font-size: 12px;
  color: #ffffff;
  text-decoration: none;
}
.footer__div__bottom__right {
  color: #ffffff;
  font-size: 12px;
}
.footer__div__line {
  width: 100%;
  height: 1px;
  background-color: #5a5252;
}
/* footer style */

/* Pricing Style */
.pricing {
  width: 100%;
}
.pricing__container {
  width: 90%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 2vmax 0;
}
.pricing__container__heading {
  font-size: 1.5vw;
  font-weight: 500;
}
.pricing__container__content {
  font-size: 16px;
  text-align: justify;
}
.pricing__container__subscribe {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.pricing__container__subscribe__card {
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 10px;
  border-radius: 8px;
  width: 32%;
  display: flex;
  flex-direction: column;
  padding: 2vw 1vw;
  align-items: center;
}
.pricing__container__subscribe__card__image {
  width: 100%;
  height: 330px;
}
.pricing__container__subscribe__card__image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.pricing__container__subscribe__card__content {
  display: flex;
  flex-direction: column;
  gap: 0.5vw;
}
.pricing__container__subscribe__card__content .heading {
  font-size: 1.75vw;
  font-weight: 900;
  text-align: center;
}

.pricing__container__subscribe__card__content .borderline {
  width: 20%;
  margin: 0 auto;
  height: 2px;
  background: black;
}
.pricing__container__subscribe__card__content .text {
  font-size: 16px;
  font-weight: 500;
  max-height: 50px;
  text-align: center;
}
.pricing__container__subscribe__card__content .buttondiv {
  width: 100%;
  text-align: center;
  padding-top: 10px;
}
.pricing__container__subscribe__card__content .buttondiv button {
  font-size: 16px;
  background: #000;
  border-radius: 8px;
  padding: 0.75vw 1.5vw;
  color: #ffffff;
  font-weight: 700;
  border: none;
  cursor: pointer;
}
.pricing__container .modal-container {
  display: none;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5); /* Transparent black background */
}

/* Modal Content Styles */
.pricing__container .modal-container .modal-content {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 20px;
  position: absolute;
  background-color: #ffffffab;
  padding: 10px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5); /* Shadow effect */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.pricing__container .modal-container .modal-content .modal-text {
  font-size: 40px;
  font-weight: 900;
}
/* Close Icon Styles */
.pricing__container .modal-container .modal-content .close-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  font-size: 96px;
  color: red;
}
.pricing__container .image {
  width: 300px;
  height: 300px;
}
.pricing__container .image img {
  width: 100%;
  height: 100%;
}
/* Pricing Style */

/* Terms Style */
.terms {
  width: 100%;
}

.terms__container {
  width: 80%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 10px 0 30px 0;
}

.terms__container__heading {
  font-size: 48px;
  font-weight: 900;
}

.terms__container__text {
  font-size: 16px;
}
.terms__container__content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.terms__container__content .heading {
  font-size: 26px;
  font-weight: 700;
}
.terms__container__content .text {
  font-size: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
/* Terms Style */

@media screen and (max-width: 768px) {
  /* navbar style */
  .webbie_container_container__navitems li a {
    font-size: 1.55vw;
  }
  .homepage__navbar__container__navitems_login div a {
    font-size: 1.55vw;
  }
  /* navbar style */

  /* home style */
  .homepage__navbar__container__navitems li a {
    font-size: 1.55vw;
  }
  .homepage__navbar__container__navitems_login div a {
    font-size: 1.55vw;
  }
  .hero {
    height: 50vh;
  }
  .homepage__bottomPart {
    height: 51vh;
    gap: 2vmax;
  }
  .homepage__partners {
    padding: 1vw 0;
  }
  /* home style */

  /* about style */
  .aboutpage__navbar__container__left__navitems li a {
    font-size: 1.75vw;
  }
  .aboutpage__navbar__container__navitems_login div a {
    font-size: 1.75vw;
  }
  .aboutpage__hero {
    height: 55vh;
  }
  .aboutpage__hero__content__div__text {
    width: 58%;
  }
  .aboutpage__hero__content__div__text__heading {
    font-size: 5vw;
  }
  .aboutpage__hero__content__div__text__content__top,
  .aboutpage__hero__content__div__text__content__bottom {
    font-size: 1.75vw;
  }
  .aboutpage__hero__content__div__text__button button {
    font-size: 1.75vw;
  }
  .aboutpage__hero__content__div__image {
    width: 42%;
  }
  .aboutpage__container__div__para p {
    font-size: 2vw;
  }
  .aboutpage__container__trustdiv {
    width: 100%;
  }
  .aboutpage__container__trustdiv__left {
    padding: 3.5vw 3vw;
  }
  .aboutpage__container__trustdiv__left__title {
    font-size: 2.25vw;
  }
  .aboutpage__container__trustdiv__left__images__top div {
    width: 40%;
  }
  .aboutpage__container__trustdiv__left__images__top div img {
    object-fit: cover;
  }
  .aboutpage__container__trustdiv__right {
    padding: 3.5vw 3vw;
  }
  .aboutpage__container__trustdiv__right div {
    font-size: 2.25vw;
  }
  .aboutpage__container__welcomdiv div:nth-child(1) {
    font-size: 2.25vw;
  }
  .aboutpage__container__welcomdiv div:nth-child(2) div {
    font-size: 1.75vw;
  }
  .aboutpage__container__support__div__card {
    justify-content: space-around;
  }
  .aboutpage__container__support__div__card img {
    width: 60px;
    height: 60px;
  }
  .aboutpage__container__support__div__card__content div:nth-child(1) {
    font-size: 1.75vw;
  }
  .aboutpage__container__support__div__card__content div:nth-child(2) {
    font-size: 1.5vw;
  }
  .aboutpage__container__support__div__card__nextbtn__imgdiv img {
    width: 20px;
    height: 20px;
  }
  .aboutpage__footer__div__top__aboutus {
    width: 45%;
  }
  .aboutpage__footer__div__top__aboutus div:nth-child(1),
  .aboutpage__footer__div__top__aboutus div:nth-child(2) {
    font-size: 1.5vw;
  }
  .aboutpage__footer__div__top__right__notifications {
    font-size: 1.5vw;
  }
  .aboutpage__footer__div__top__right__notifications li a {
    font-size: 1.5vw;
  }
  .aboutpage__footer__div__top__right__form__heading {
    font-size: 1.5vw;
  }
  .aboutpage__footer__div__top__right__form__button button {
    font-size: 1.5vw;
  }
  .aboutpage__footer__div__bottom__left span {
    font-size: 1.5vw;
  }
  .aboutpage__footer__div__bottom__left span a {
    font-size: 1.5vw;
  }
  .aboutpage__footer__div__bottom__right {
    font-size: 1.5vw;
  }
  /* about style */
  .aboutpage__hero {
    height: 45vh;
  }
  .aboutpage__hero__content__div__text {
    width: 58%;
  }
  .aboutpage__hero__content__div__text__heading {
    font-size: 5vw;
  }
  .aboutpage__hero__content__div__text__content {
    width: 90%;
  }
  .aboutpage__hero__content__div__text__content__top,
  .aboutpage__hero__content__div__text__content__bottom {
    font-size: 1.75vw;
  }
  .aboutpage__hero__content__div__text__button button {
    font-size: 1.75vw;
  }
  .aboutpage__hero__content__div__image {
    width: 42%;
  }
  .aboutpage__container__div__para p {
    font-size: 2vw;
  }
  .aboutpage__container__trustdiv {
    width: 100%;
  }
  .aboutpage__container__trustdiv__left {
    padding: 3.5vw 3vw;
  }
  .aboutpage__container__trustdiv__left__title {
    font-size: 2.25vw;
  }
  .aboutpage__container__trustdiv__left__images__top div {
    width: 40%;
  }
  .aboutpage__container__trustdiv__left__images__top div img {
    object-fit: cover;
  }
  .aboutpage__container__trustdiv__right {
    padding: 3.5vw 3vw;
  }
  .aboutpage__container__trustdiv__right div {
    font-size: 2.25vw;
  }
  .aboutpage__container__welcomdiv div:nth-child(1) {
    font-size: 2.25vw;
  }
  .aboutpage__container__welcomdiv div:nth-child(2) div {
    font-size: 1.75vw;
  }
  .aboutpage__container__support__div__card {
    justify-content: space-around;
  }
  .aboutpage__container__support__div__card img {
    width: 60px;
    height: 60px;
  }
  .aboutpage__container__support__div__card__content div:nth-child(1) {
    font-size: 1.75vw;
  }
  .aboutpage__container__support__div__card__content div:nth-child(2) {
    font-size: 1.5vw;
  }
  .aboutpage__container__support__div__card__nextbtn__imgdiv img {
    width: 20px;
    height: 20px;
  }
  /* about style */

  /* contact style */

  .contactuspage__hero {
    height: 45vh;
  }
  .contactuspage__hero__content__div__text {
    width: 58%;
  }
  .contactuspage__hero__content__div__text__heading {
    font-size: 5vw;
  }
  .contactuspage__hero__content__div__text__content {
    width: 90%;
  }
  .contactuspage__hero__content__div__text__content__top,
  .contactuspage__hero__content__div__text__content__bottom {
    font-size: 1.75vw;
  }
  .contactuspage__hero__content__div__text__button button {
    font-size: 1.75vw;
  }
  .contactuspage__hero__content__div__image {
    width: 42%;
  }
  .contactuspage__container__div__para p {
    font-size: 2vw;
  }
  .contactuspage__container__trustdiv {
    width: 100%;
  }
  .contactuspage__container__trustdiv__left {
    padding: 3.5vw 3vw;
  }
  .contactuspage__container__trustdiv__left__title {
    font-size: 2.25vw;
  }
  .contactuspage__container__trustdiv__left__images__top div {
    width: 40%;
  }
  .contactuspage__container__trustdiv__left__images__top div img {
    object-fit: cover;
  }
  .contactuspage__container__trustdiv__right {
    padding: 3.5vw 3vw;
  }
  .contactuspage__container__trustdiv__right div {
    font-size: 2.25vw;
  }
  .contactuspage__container__welcomdiv div:nth-child(1) {
    font-size: 2.25vw;
  }
  .contactuspage__container__welcomdiv div:nth-child(2) div {
    font-size: 1.75vw;
  }
  .contactuspage__container__support__div__card {
    justify-content: space-around;
  }
  .contactuspage__container__support__div__card img {
    width: 60px;
    height: 60px;
  }
  .contactuspage__container__support__div__card__content div:nth-child(1) {
    font-size: 1.75vw;
  }
  .contactuspage__container__support__div__card__content div:nth-child(2) {
    font-size: 1.5vw;
  }
  .contactuspage__container__support__div__card__nextbtn__imgdiv img {
    width: 20px;
    height: 20px;
  }
  /* contact style */

  /* payment style */
  .payments__hero {
    height: 45vh;
  }
  .payments__hero__content__div__text {
    width: 58%;
  }
  .payments__hero__content__div__text__heading {
    font-size: 4vw;
  }
  .payments__hero__content__div__text__content__top,
  .payments__hero__content__div__text__content__bottom {
    font-size: 1.75vw;
  }
  .payments__hero__content__div__text__button button {
    font-size: 1.75vw;
  }
  .payments__hero__content__div__image {
    width: 42%;
  }
  .payments__container__toppart__heading {
    font-size: 3vw;
    letter-spacing: 0;
  }
  .payments__container__toppart__box__content__div {
    width: 40%;
  }
  .payments__container__toppart__box__content__div__wrapper {
    top: 23px;
  }
  .payments__container__toppart__box__content__div__wrapper .heading {
    font-size: 2.5vw;
  }
  .payments__container__toppart__box__content__div__wrapper .text {
    font-size: 2vw;
  }
  .payments__container__toppart__box__content .bg {
    top: 3%;
    height: 35vh;
  }
  .payments__container__support__div__card {
    justify-content: space-around;
  }
  .payments__container__support__div__card img {
    width: 60px;
    height: 60px;
  }
  .payments__container__support__div__card__content div:nth-child(1) {
    font-size: 1.75vw;
  }
  .payments__container__support__div__card__content div:nth-child(2) {
    font-size: 1.5vw;
  }
  .payments__container__support__div__card__nextbtn__imgdiv img {
    width: 20px;
    height: 20px;
  }
  /* payment style */

  /* partners style */
  .partnerspage__hero {
    height: 45vh;
  }
  .partnerspage__hero__content__div__left {
    width: 60%;
  }
  .partnerspage__hero__content__div__left__text {
    padding-left: 10%;
  }
  .partnerspage__hero__content__div__left__text__heading {
    font-size: 5vw;
  }
  .partnerspage__hero__content__div__left__text__content {
    width: 90%;
  }
  .partnerspage__hero__content__div__left__text__content__top,
  .partnerspage__hero__content__div__left__text__content__bottom {
    font-size: 1.75vw;
  }
  .partnerspage__hero__content__div__left__text__button button {
    font-size: 1.75vw;
  }
  .partnerspage__hero__content__div__image {
    width: 40%;
  }
  .partnerspage__container__div__para p {
    font-size: 2vw;
  }
  .partnerspage__container__trustdiv {
    width: 100%;
  }
  .partnerspage__container__trustdiv__left {
    padding: 3.5vw 3vw;
  }
  .partnerspage__container__trustdiv__left__title {
    font-size: 2.25vw;
  }
  .partnerspage__container__trustdiv__left__images__top div {
    width: 40%;
  }
  .partnerspage__container__trustdiv__left__images__top div img {
    object-fit: cover;
  }
  .partnerspage__container__trustdiv__right {
    padding: 3.5vw 3vw;
  }
  .partnerspage__container__trustdiv__right div {
    font-size: 2.25vw;
  }
  .partnerspage__container__welcomdiv div:nth-child(1) {
    font-size: 2.25vw;
  }
  .partnerspage__container__welcomdiv div:nth-child(2) div {
    font-size: 1.75vw;
  }
  .partnerspage__container__support__div__card {
    justify-content: space-around;
  }
  .partnerspage__container__support__div__card img {
    width: 60px;
    height: 60px;
  }
  .partnerspage__container__support__div__card__content div:nth-child(1) {
    font-size: 1.75vw;
  }
  .partnerspage__container__support__div__card__content div:nth-child(2) {
    font-size: 1.5vw;
  }
  .partnerspage__container__support__div__card__nextbtn__imgdiv img {
    width: 20px;
    height: 20px;
  }
  /* partners style */

  /* shipping style */
  .shipping__hero {
    height: 45vh;
  }
  .shipping__hero__content__div__text {
    width: 58%;
  }
  .shipping__hero__content__div__text__heading {
    font-size: 4vw;
  }
  .shipping__hero__content__div__text__content__top,
  .shipping__hero__content__div__text__content__bottom {
    font-size: 1.75vw;
  }
  .shipping__hero__content__div__text__button button {
    font-size: 1.75vw;
  }
  .shipping__hero__content__div__image {
    width: 42%;
  }
  .shipping__container__toppart__heading {
    font-size: 3vw;
    letter-spacing: 0;
  }
  .shipping__container__toppart__box__content__div {
    width: 45%;
  }
  .shipping__container__toppart__box__content__div__wrapper .heading {
    font-size: 16px;
  }
  .shipping__container__toppart__box__content__div__wrapper .text {
    font-size: 14px;
  }
  .shipping__container__toppart__box__content .bg {
    top: 3%;
  }
  .shipping__container__support__div__card {
    justify-content: space-around;
  }
  .shipping__container__support__div__card img {
    width: 60px;
    height: 60px;
  }
  .shipping__container__support__div__card__content div:nth-child(1) {
    font-size: 1.75vw;
  }
  .shipping__container__support__div__card__content div:nth-child(2) {
    font-size: 1.5vw;
  }
  .shipping__container__support__div__card__nextbtn__imgdiv img {
    width: 20px;
    height: 20px;
  }
  /* shipping style */
}

@media screen and (max-width: 580px) {
  /* navbar */
  .header__navbar {
    height: 8vh;
  }
  .header_logo img {
    width: 180px;
  }
  .webbie_container_container__navitems {
    display: none;
  }
  .homepage__navbar__container__navitems_login {
    display: none;
  }
  .homepage__navbar__hamburger {
    display: block;
    cursor: pointer;
  }
  .homepage__navbar__hamburger i {
    font-size: 24px;
  }
  /*  navbar */

  /* home style */
  .homepage__navbar {
    height: 8vh;
  }
  .homepage__navbar__container__logo img {
    width: 180px;
  }
  .homepage__navbar__container__navitems {
    display: none;
  }
  .homepage__navbar__container__navitems_login {
    display: none;
  }
  .homepage__navbar__hamburger {
    display: block;
    cursor: pointer;
  }
  .homepage__navbar__hamburger i {
    font-size: 24px;
  }
  .hero {
    height: 50vh;
    width: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    object-position: 50% center; /* Centers the image horizontally and vertically */
    background-repeat: no-repeat;
  }
  .hero__herosection__img1,
  .hero__herosection__img2 {
    position: static;
    display: none;
  }
  .hero__content__div__text {
    width: 100%;
    text-align: center;
    gap: 12px;
  }
  .hero__content__div__text__heading {
    font-size: 24px;
  }
  .hero__content__div__text__content {
    font-size: 15px;
    font-weight: 300;
    width: 97%;
    margin: 0 auto;
  }
  .hero__content__div__text__button a {
    font-size: 18px;
    padding: 8px 12px;
  }
  .hero__content__div__image {
    display: none;
    width: 0px;
  }
  .homepage__bussinessbox__container {
    width: 90%;
    flex-direction: column;
  }
  .homepage__bussinessbox__container__img1,
  .homepage__bussinessbox__container__img2,
  .homepage__bussinessbox__container__img3 {
    width: 100%;
  }
  .homepage__bussinessbox__container__img1__div,
  .homepage__bussinessbox__container__img2__div,
  .homepage__bussinessbox__container__img3__div {
    width: 100%;
  }

  .homepage__bussinessbox__container__img1__div div,
  .homepage__bussinessbox__container__img2__div div,
  .homepage__bussinessbox__container__img3__div div {
    font-size: 20px;
  }
  .homepage__bussinessbox__container__plus,
  .homepage__bussinessbox__container__equal {
    font-size: 96px;
  }

  .homepage__bussinessbox__container__text {
    flex-direction: row;
    width: -moz-fit-content;
    width: fit-content;
    max-width: 90%;
    gap: 5px;
    /* margin: 0 auto; */
  }
  .homepage__bussinessbox__container__text span {
    font-size: 26px;
  }

  .homepage__bsimplified__container {
    width: 90%;
    padding: 0;
    flex-direction: column;
    gap: 20px;
  }
  .homepage__bsimplified__container__content {
    width: 100%;
  }
  .homepage__bsimplified__container__content__heading {
    font-size: 26px;
    text-align: center;
  }
  .homepage__bsimplified__container__content__list {
    gap: 20px;
    padding-left: 20px;
  }
  .homepage__bsimplified__container__content__signupbtn {
    justify-content: center;
  }
  .homepage__bsimplified__container__content__list li span {
    font-size: 16px;
  }
  .homepage__bsimplified__container__content__signupbtn a span {
    font-size: 20px;
  }
  .homepage__bsimplified__right {
    width: 100%;
  }
  .homepage__bottomPart {
    height: auto;
    padding: 5vh 0;
  }
  .homepage__bottomPart__businessgrow {
    flex-direction: column;
    align-items: center;
    gap: 4vmax;
    width: 100%;
  }
  .homepage__bottomPart__businessgrow__image {
    position: static;
    width: 90%;
    height: 50vh;
    margin-bottom: 20px;
  }
  .homepage__bottomPart__businessgrow__image__topcontent {
    gap: 7px;
  }
  .homepage__bottomPart__businessgrow__image__topcontent
    div:nth-child(3)
    span:nth-child(1) {
    font-size: 20px;
  }
  .homepage__bottomPart__businessgrow__image__topcontent
    div:nth-child(3)
    span:nth-child(2) {
    font-size: 14px;
  }
  .homepage__bottomPart__businessgrow__image__topcontent
    div:nth-child(4)
    button {
    font-size: 18px;
    padding: 6px 18px;
  }
  .homepage__bottomPart__businessgrow__image__topcontent div:nth-child(5) p {
    font-size: 12px;
  }
  .homepage__bottomPart__businessgrow__right {
    width: 90%;
    position: static;
    height: auto;
    gap: 20px;
  }
  .homepage__bottomPart__businessgrow__right__content {
    font-size: 26px;
    text-align: center;
  }

  .homepage__partners__div {
    width: 90%;
  }
  .homepage__partners__div__head {
    text-align: center;
  }
  .homepage__partners__div__head span:nth-child(1),
  .homepage__partners__div__head span:nth-child(3) {
    display: none;
  }
  .homepage__partners__div__head span:nth-child(2) {
    width: 100%;
    font-size: 26px;
  }
  .slick-slide {
    display: flex !important;
    justify-content: center;
    align-items: center;
  }
  /* .homepage__partners__div__brandlogos {
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 30px;
    padding-bottom: 10px;
  } */
  .homepage__partners__div__brandlogos__c1 {
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 6%;
  }
  .homepage__partners__div__brandlogos__c1 div img {
    width: 160px;
    height: 35px;
    object-fit: contain;
  }
  .homepage__partners__div__brandlogos__c1 div:nth-child(2) img,
  .homepage__partners__div__brandlogos__c1 div:nth-child(3) img,
  .homepage__partners__div__brandlogos__c1 div:nth-child(4) img {
    width: 150px;
    height: 35px;
  }

  .homepage__support__div {
    width: 90%;
    flex-direction: column;
    gap: 30px;
  }
  .homepage__support__div__card {
    width: 100%;
    padding: 20px;
    gap: 30px;
  }
  .homepage__support__div__card__image img {
    width: 70px;
    height: 70px;
  }
  .homepage__support__div__card__nextbtn__imgdiv {
    padding: 6px 24px;
    font-size: 16px;
    border-radius: 20px;
  }

  .homepage__support__div__card__image .roundshape {
    height: 30px;
    width: 30px;
    top: 22px;
  }
  .homepage__support__div__card__content div:nth-child(1) {
    font-size: 20px;
  }
  .homepage__support__div__card__content div:nth-child(2) {
    font-size: 14px;
    font-weight: 300;
  }
  .homepage__footer__div__top__aboutus div:nth-child(1) {
    font-size: 2vw;
  }
  .homepage__footer__div__top__aboutus div:nth-child(2) {
    font-size: 2vw;
  }
  .homepage__footer__div__top__right__notifications {
    font-size: 2vw;
  }
  .homepage__footer__div__top__right__notifications li a {
    font-size: 2vw;
  }
  .homepage__footer__div__top__right__form {
    width: 60%;
  }
  .homepage__footer__div__top__right__form button {
    font-size: 2vw;
  }
  .homepage__footer__div__bottom__left span {
    font-size: 1.5vw;
  }
  .homepage__footer__div__bottom__left span a {
    font-size: 1.5vw;
  }
  .homepage__footer__div__bottom__right {
    font-size: 1.5vw;
  }
  /* home style */

  /* about style */
  .aboutpage__container {
    width: 90%;
  }
  .aboutpage__container__div__para p {
    font-size: 14px;
  }
  .aboutpage__container__trustdiv {
    flex-direction: column;
    gap: 20px;
  }
  .aboutpage__container__trustdiv__left {
    width: 100%;
    padding: 12px 16px;
  }
  .aboutpage__container__trustdiv__left__title {
    font-size: 20px;
  }
  .aboutpage__container__trustdiv__left__images__top {
    justify-content: space-between;
  }
  .aboutpage__container__trustdiv__left__images__top div {
    width: 45%;
  }
  .aboutpage__container__trustdiv__right {
    width: 100%;
    padding: 12px 16px;
    gap: 32px;
  }
  .aboutpage__container__trustdiv__right div {
    font-size: 20px;
  }
  .aboutpage__container__trustdiv__right__nextbtn__imgdiv {
    width: 35px;
    height: 35px;
  }
  .aboutpage__container__trustdiv__right__nextbtn__imgdiv img {
    width: 25px;
  }
  .aboutpage__container__welcomediv {
    width: 90%;
  }
  .aboutpage__container__welcomediv div:nth-child(1) {
    font-size: 20px;
  }
  .aboutpage__container__welcomediv div:nth-child(2) {
    flex-direction: column;
    gap: 10px;
  }
  .aboutpage__container__welcomediv div:nth-child(2) div {
    width: 100%;
  }

  /* about style */

  /* contact style */

  .contactuspage__container {
    width: 90%;
  }
  .contactuspage__container__div__para__form__container {
    width: 100%;
  }
  .contactuspage__container__div__para__form__container .heading {
    font-size: 20px;
  }
  .contact__form {
    gap: 20px;
  }
  .contact__form__inputfield {
    width: 100%;
  }
  .contact__form__label {
    font-size: 14px;
  }
  .contact__form__inputfield input,
  select {
    font-size: 14px;
  }
  .contact__form__inputfield select {
    font-size: 14px;
  }

  .contact__form__inputfield input::placeholder {
    font-size: 14px;
  }
  .contact__form__contactemail {
    flex-direction: column;
    width: 100%;
    gap: 20px;
  }
  .contact__form__contactemail div {
    width: 100%;
    gap: 12px;
  }
  #contact__form__inputfield__button {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .contact__form__button__submit {
    font-size: 16px;
    padding: 8px 16px;
    margin: 0;
  }
  .contactuspage__container__trustdiv__right__nextbtn__imgdiv {
    width: 25px;
    height: 25px;
  }
  .contactuspage__container__trustdiv__right__nextbtn__imgdiv img {
    width: 20px;
    height: 20px;
  }
  .contactuspage__container__welcomediv__title span:nth-child(1),
  .contactuspage__container__welcomediv__title span:nth-child(3) {
    display: none;
  }
  .contactuspage__container__welcomediv__title {
    width: 100%;
    font-size: 20px;
    justify-content: center;
  }
  .contactuspage__container__welcomediv__div1,
  .contactuspage__container__welcomediv__div2 {
    flex-direction: column;
    gap: 20px;
  }

  .contactuspage__container__welcomediv__div1 div,
  .contactuspage__container__welcomediv__div2 div {
    width: 100%;
  }
  /* contact style */

  /* payment style */
  .payments__container,
  .shipping__container {
    width: 90%;
  }
  .payments__container__partners {
    padding: 0;
  }
  .payments__container__partners__div__head span:nth-child(1),
  .payments__container__partners__div__head span:nth-child(3) {
    display: none;
  }
  .payments__container__partners__div__head span:nth-child(2) {
    width: 100%;
    font-size: 26px;
  }
  .payments__container__partners__div__brandlogos {
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 25px;
  }
  .payments__container__partners__div__brandlogos div {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .payments__container__partners__div__brandlogos div img {
    width: 200px;
    height: 40px;
    object-fit: contain;
  }
  .payments__container__partners__div__brandlogos div:nth-child(2) img,
  .payments__container__partners__div__brandlogos div:nth-child(3) img,
  .payments__container__partners__div__brandlogos div:nth-child(4) img {
    width: 186px;
    height: 35px;
  }

  .payments__container__toppart__heading {
    font-size: 20px;
    text-align: center;
  }
  .payments__container__toppart__box__content__div__wrapper {
    left: 8px;
  }
  .payments__container__toppart__box__content__div__wrapper .heading {
    font-size: 16px;
  }
  .payments__container__toppart__box__content__div__wrapper .text {
    padding-top: 20px;
    font-size: 13px;
  }
  .payments__container__toppart__box__content {
    flex-direction: column;
    gap: 70px;
  }
  .payments__container__toppart__box__content__div {
    height: 200px;
    min-height: 200px;
    width: 100%;
  }
  .payments__container__toppart__box__content__div__wrapper {
    height: 200px;
    min-height: 200px;
  }
  .payments__container__toppart__box__content__div .bg {
    height: 250px;
    min-height: 250px;
    top: 3%;
    left: -1px;
  }
  .payments__container__partners__div__button {
    margin-top: 6vh;
  }
  .payments__container__partners__div__button a {
    font-size: 16px;
    padding: 8px 16px;
    border-radius: 6px;
  }

  /* payment style */

  /* partners style */
  .partnerspage__hero {
    height: 50vh;
    width: 100%;
    text-align: center;
  }
  .partnerspage__hero__content__div__left {
    width: 100%;
  }
  .partnerspage__hero__content__div__left__text {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .partnerspage__hero__content__div__text {
    width: 100%;
  }
  .partnerspage__hero__content__div__left__text__heading {
    font-size: 24px;
  }
  .partnerspage__hero__content__div__left__text__content {
    width: 100%;
    gap: 20px;
  }
  .partnerspage__hero__content__div__left__text__content__top {
    font-size: 15px;
    font-weight: 300;
    width: 100%;
    margin: 0 auto;
  }
  .partnerspage__hero__content__div__left__text {
    padding: 0;
  }
  .partnerspage__hero__content__div__left__text__button a {
    font-size: 18px;
    padding: 8px 12px;
  }
  .partnerspage__hero__content__div__image {
    display: none;
  }

  .partnerspage__container__trustdiv__right__nextbtn__imgdiv {
    width: 25px;
    height: 25px;
  }
  .partnerspage__container__trustdiv__right__nextbtn__imgdiv img {
    width: 20px;
    height: 20px;
  }
  .partnerspage__container__div__para {
    flex-direction: column;
  }
  .partnerspage__container__div__para__box {
    width: 100%;
  }
  .partnerspage__container__div__para__equal {
    font-size: 96px;
  }
  .partnerspage__container__welcomediv__title {
    width: 90%;
    font-size: 20px;
    justify-content: center;
  }
  .partnerspage__container__welcomediv__title span:nth-child(1),
  .partnerspage__container__welcomediv__title span:nth-child(3) {
    display: none;
  }
  .partnerspage__container__welcomediv__div1,
  .partnerspage__container__welcomediv__div2 {
    flex-direction: column;
    gap: 20px;
  }
  .partnerspage__container__welcomediv__div1 div,
  .partnerspage__container__welcomediv__div2 div {
    width: 100%;
    font-size: 16px;
  }

  /* partners style */

  /* shipping style */
  .shipping__container__toppart__heading {
    font-size: 20px;
    text-align: center;
  }
  .shipping__container__toppart__box__content__div__wrapper .heading {
    font-size: 20px;
    font-weight: 700;
  }
  .shipping__container__toppart__box__content__div__wrapper .text {
    font-size: 16px;
  }
  .shipping__container__toppart__box__content {
    flex-direction: column;
    gap: 40px;
  }
  .shipping__container__toppart__box__content__div {
    height: 200px;
    min-height: 200px;
    width: 100%;
  }
  .shipping__container__toppart__box__content__div__wrapper {
    height: 200px;
    min-height: 200px;
  }
  .shipping__container__toppart__box__content__div .bg {
    height: 200px;
    min-height: 200px;
    top: 7%;
  }
  /* shipping style */

  /* footer style */
  .footer__div__top {
    flex-direction: column;
    gap: 20px;
  }
  .footer__div__top__aboutus {
    width: 100%;
  }
  .footer__div__top__aboutus div:nth-child(1) {
    font-size: 16px;
  }
  .footer__div__top__aboutus div:nth-child(2) {
    font-size: 14px;
  }
  .footer__div__top__aboutus div:nth-child(3) {
    font-size: 20px;
    padding: 4px 0;
  }
  .footer__div__top__right__notifications__heading {
    font-size: 16px;
  }

  .footer__div__top__right {
    flex-direction: column;
    gap: 20px;
    width: 100%;
    padding-left: 0;
  }
  .footer__div__top__right__notifications {
    font-size: 2vw;
    width: 100%;
  }
  .footer__div__top__right__notifications li a {
    font-size: 14px;
  }
  .footer__div__top__right__form {
    width: 100%;
  }
  .footer__div__top__right__form input {
    width: 90%;
    padding: 10px;
    border-radius: 5px;
  }
  .footer__div__top__right__form button {
    font-size: 16px;
    width: -moz-fit-content;
    width: fit-content;
    padding: 8px 32px;
    border-radius: 5px;
  }
  .footer__div__bottom {
    flex-direction: column;
    gap: 20px;
  }
  .footer__div__bottom__left span {
    font-size: 13px;
  }
  .footer__div__bottom__left span a {
    font-size: 13px;
  }
  .footer__div__bottom__right {
    font-size: 13px;
  }
  /* footer style */

  /* Pricing Style */
  .pricing__container__heading {
    font-size: 20px;
  }
  .pricing__container__content {
    font-size: 14px;
  }
  .pricing__container__subscribe__card__content .heading {
    font-size: 20px;
  }
  .pricing__container__subscribe {
    flex-direction: column;
    gap: 20px;
  }
  .pricing__container__subscribe__card {
    padding: 20px 0 40px;
    width: 100%;
  }
  .pricing__container__subscribe__card__content .buttondiv button {
    font-size: 18px;
    padding: 8px 16px;
  }
  /* pricing style */
}
@media (min-width: 360px) and (max-width: 580px) {
  .payments__container__toppart__heading,
  .shipping__container__toppart__heading {
    font-size: 15px;
    text-align: center;
  }
  .overlay-wrapper .subscription-card .statement {
    font-size: 1rem !important;
    text-align: center;
  }
}
@media (max-width: 1438px) {
  lottie-player {
    width: 300px !important;
  }
}

@media (max-width: 1124px) {
  #animation-container {
    display: none;
  }
}

.slider--all-heading {
  color: #ffffff;
  font-size: var(--hero-font);
  font-weight: 1000;
}
`, "",{"version":3,"sources":["webpack://./src/views/Landing/globalstylesheet.css"],"names":[],"mappings":"AAGA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kCAAkC;AACpC;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB;;;uBAGqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,UAAU;EAEV,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,WAAW;EAEX,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,cAAc;EACd,WAAW;EACX,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB;;2BAEyB;EACzB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,eAAe;EACf,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;AACnB;AAIA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AACA;EACE,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;AACA,kBAAkB;;AAElB,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,aAAa;AACf;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,UAAU;EAEV,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,WAAW;EAEX,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,cAAc;EACd,WAAW;EACX,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,eAAe;EACf,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,WAAW;AACb;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;AAIA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;AAIA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;AAC7B;AACA,kBAAkB;;AAElB,iBAAiB;AACjB;EACE,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,cAAc;EACd,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,OAAO;EACP,MAAM;EAEN,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,OAAO;EACP,MAAM;EAEN,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,YAAY;EACZ,UAAU;EACV,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,WAAW;EACX,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,oCAAoC;EACpC,SAAS;AACX;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;EACV,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;AACA;;;EAGE,UAAU;AACZ;AACA;;;EAGE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,uBAAuB;AACzB;AACA;;;EAGE,WAAW;EAEX,iBAAiB;AACnB;AACA;;;EAGE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;AACA;;EAEE,SAAS;EACT,uCAAuC;EACvC,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;AACA;EAEE,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,YAAY;EACZ,cAAc;AAChB;AACA;EACE,UAAU;EACV,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,2CAA2C;EAC3C,kBAAkB;AACpB;AACA;EAEE,iBAAiB;EACjB,WAAW;EACX,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,WAAW;EAEX,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;;;EAGE,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;EACd,sCAAsC;EACtC,gBAAgB;AAClB;AACA;;;EAGE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,UAAU;EACV,cAAc;AAChB;AACA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;EACd,4BAA4B;AAC9B;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,sCAAsC;EACtC,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,aAAa;EACb,OAAO;EACP,mBAAmB;AACrB;AACA;;EAEE,WAAW;EACX,yBAAyB;EACzB,UAAU;AACZ;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,UAAU;EACV,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,2CAA2C;AAC7C;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,OAAO;EACP,YAAY;EACZ,WAAW;EACX,kDAAkD;EAClD,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;AACZ;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA,mBAAmB;;AAEnB,gBAAgB;AAChB;EACE,WAAW;AACb;AACA;EACE,UAAU;EACV,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,cAAc;EACd,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,aAAa;EACb,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EAEX,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;AACA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,sCAAsC;EACtC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,WAAW;EACX,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;AACA,gBAAgB;;AAEhB,kBAAkB;;AAElB;EACE,WAAW;AACb;AACA;EACE,UAAU;EACV,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;AACA;;EAEE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;;EAEE,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;AACA;;EAEE,aAAa;EACb,6BAA6B;AAC/B;AACA;;EAEE,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,kBAAkB;;AAElB,mBAAmB;;AAEnB;EACE,UAAU;EACV,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,WAAW;AACb;AACA;EACE,WAAW;EACX,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,SAAS;EACT,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,YAAY;AACd;AACA;EACE,aAAa;EACb,OAAO;EACP,mBAAmB;AACrB;AACA;;EAEE,WAAW;EACX,yBAAyB;EACzB,UAAU;AACZ;AACA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,WAAW;EAEX,iBAAiB;AACnB;AACA,mBAAmB;;AAEnB,mBAAmB;;AAEnB;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,sDAAsD;AACxD;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;EACV,6DAA6D;AAC/D;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,2BAA2B;EAC3B,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EAEZ,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,uCAAuC;EACvC,cAAc;EACd,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EAEX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;;EAEE,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;AACA;;EAEE,aAAa;EACb,6BAA6B;AAC/B;AACA;;EAEE,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,mBAAmB;;AAEnB,oBAAoB;AACpB;EACE,WAAW;AACb;AACA;EACE,UAAU;EACV,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,WAAW;AACb;AACA;EACE,WAAW;EACX,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,OAAO;EACP,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;;AAEA,mBAAmB;;AAEnB,iBAAiB;;AAEjB;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;AAChB;AACA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,SAAS;AACX;AACA;EACE,cAAc;AAChB;AACA;EACE,UAAU;EACV,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,uBAAkB;EAAlB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,YAAY;AACd;AACA;EACE,UAAU;EACV,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;AACA,iBAAiB;;AAEjB,kBAAkB;AAClB;EACE,WAAW;AACb;AACA;EACE,UAAU;EACV,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;AAChC;AACA;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,OAAO;EACP,MAAM;EACN,WAAW;EACX,aAAa;EACb,oCAAoC,EAAE,iCAAiC;AACzE;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uCAAuC,EAAE,kBAAkB;EAC3D,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,eAAe;EACf,UAAU;AACZ;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA,kBAAkB;;AAElB,gBAAgB;AAChB;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA,gBAAgB;;AAEhB;EACE,iBAAiB;EACjB;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA,iBAAiB;;EAEjB,eAAe;EACf;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;IACZ,UAAU;EACZ;EACA;IACE,cAAc;EAChB;EACA,eAAe;;EAEf,gBAAgB;EAChB;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,cAAc;EAChB;EACA;;IAEE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IAEE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;;IAEE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA,gBAAgB;EAChB;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,cAAc;EAChB;EACA;IACE,UAAU;EACZ;EACA;;IAEE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IAEE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA,gBAAgB;;EAEhB,kBAAkB;;EAElB;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,cAAc;EAChB;EACA;IACE,UAAU;EACZ;EACA;;IAEE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IAEE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA,kBAAkB;;EAElB,kBAAkB;EAClB;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,cAAc;EAChB;EACA;;IAEE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,OAAO;IACP,YAAY;EACd;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA,kBAAkB;;EAElB,mBAAmB;EACnB;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;EACA;IACE,UAAU;EACZ;EACA;;IAEE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IAEE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA,mBAAmB;;EAEnB,mBAAmB;EACnB;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,cAAc;EAChB;EACA;;IAEE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,OAAO;EACT;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA,YAAY;;EAEZ,eAAe;EACf;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,WAAW;IACX,yDAA0E;IAC1E,sBAAsB;IACtB,2BAA2B,EAAE,kDAAkD;IAC/E,4BAA4B;EAC9B;EACA;;IAEE,gBAAgB;IAChB,aAAa;EACf;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,cAAc;EAChB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,UAAU;EACZ;EACA;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;;;IAGE,WAAW;EACb;EACA;;;IAGE,WAAW;EACb;;EAEA;;;IAGE,eAAe;EACjB;EACA;;IAEE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,uBAAkB;IAAlB,kBAAkB;IAClB,cAAc;IACd,QAAQ;IACR,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,UAAU;IACV,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,SAAS;IACT,kBAAkB;EACpB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;IACZ,cAAc;EAChB;EACA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;IACV,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,QAAQ;EACV;EACA;;;IAGE,eAAe;EACjB;EACA;;;IAGE,eAAe;EACjB;EACA;;;IAGE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,SAAS;EACX;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,UAAU;EACZ;EACA;IACE,kBAAkB;EACpB;EACA;;IAEE,aAAa;EACf;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,wBAAwB;IACxB,uBAAuB;IACvB,mBAAmB;EACrB;EACA;;;;;;KAMG;EACH;IACE,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,OAAO;EACT;EACA;IACE,YAAY;IACZ,YAAY;IACZ,mBAAmB;EACrB;EACA;;;IAGE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,UAAU;IACV,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,WAAW;IACX,aAAa;IACb,SAAS;EACX;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,UAAU;EACZ;EACA;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA,eAAe;;EAEf,gBAAgB;EAChB;IACE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,WAAW;EACb;;EAEA,gBAAgB;;EAEhB,kBAAkB;;EAElB;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;;IAEE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,WAAW;IACX,SAAS;EACX;EACA;IACE,WAAW;IACX,SAAS;EACX;EACA;IACE,WAAW;IACX,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;;IAEE,aAAa;EACf;EACA;IACE,WAAW;IACX,eAAe;IACf,uBAAuB;EACzB;EACA;;IAEE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,WAAW;EACb;EACA,kBAAkB;;EAElB,kBAAkB;EAClB;;IAEE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;;IAEE,aAAa;EACf;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,SAAS;EACX;EACA;IACE,WAAW;IACX,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,YAAY;IACZ,YAAY;IACZ,mBAAmB;EACrB;EACA;;;IAGE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,aAAa;IACb,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,iBAAiB;IACjB,OAAO;IACP,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA,kBAAkB;;EAElB,mBAAmB;EACnB;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,SAAS;EACX;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,cAAc;EAChB;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,UAAU;IACV,eAAe;IACf,uBAAuB;EACzB;EACA;;IAEE,aAAa;EACf;EACA;;IAEE,sBAAsB;IACtB,SAAS;EACX;EACA;;IAEE,WAAW;IACX,eAAe;EACjB;;EAEA,mBAAmB;;EAEnB,mBAAmB;EACnB;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,aAAa;IACb,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,iBAAiB;IACjB,OAAO;EACT;EACA,mBAAmB;;EAEnB,iBAAiB;EACjB;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,eAAe;EACjB;EACA;IACE,cAAc;IACd,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;IACV,aAAa;IACb,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,uBAAkB;IAAlB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA,iBAAiB;;EAEjB,kBAAkB;EAClB;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,oBAAoB;IACpB,WAAW;EACb;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA,kBAAkB;AACpB;AACA;EACE;;IAEE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,kBAAkB;EACpB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,iBAAiB;AACnB","sourcesContent":["@import url(\"https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css\");\n@import url(\"https://fonts.googleapis.com/css2?family=Qwitcher+Grypen&display=swap\");\n\n:root {\n  --hero-font: 3vw;\n  --section-heading-font: 2vw;\n}\n\n* {\n  box-sizing: border-box;\n  padding: 0;\n  margin: 0;\n  font-family: \"Manrope\", sans-serif;\n}\n\nbody {\n  height: 100vh;\n  width: 100%;\n  font-family: \"Manrope\", sans-serif;\n}\n\n/* sign in style */\n.signin {\n  width: 100%;\n  height: 100%;\n  /* display: flex; */\n}\n.signin__leftimg {\n  /* width: 40%; */\n  /* width: 35%;\n  min-width: 500px;\n  height: 100%;\n  position: relative; */\n}\n.signin__leftimg__img {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  z-index: 1;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n.signin__leftimg__img-cover {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  z-index: 99;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n.signin__leftimg__textcontainer {\n  position: absolute;\n  z-index: 100;\n  bottom: 23%;\n  color: #ffffff;\n  width: 100%;\n  padding: 0 4vw;\n  display: flex;\n  flex-direction: column;\n  gap: 2vw;\n}\n.signin__leftimg__textcontainer div {\n  line-height: 35.5px;\n}\n.signin__leftimg__textcontainer__heading {\n  font-size: 2.3vw;\n  font-weight: bolder;\n}\n.signin__leftimg__textcontainer__content {\n  font-size: 1.05vw;\n  font-weight: normal;\n}\n.signin__right {\n  display: flex;\n  /* width: 60%; */\n  /* width: 75%;\n  height: 100%;\n  flex-direction: column; */\n  /* gap: 10vmin; */\n  /* padding: 2.2vw 4vw; */\n  overflow: hidden;\n}\n.signin__right__top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.signin__right__top__btn {\n  text-decoration: none;\n  background-color: #eff1f4;\n  color: #cd1479;\n  font-size: 14px;\n  font-weight: 600;\n  display: flex;\n  gap: 0.75vw;\n  align-items: center;\n  padding: 9px 12px;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n}\n.signin__right__top__rightcontent {\n  font-size: 14px;\n}\n.signin__right__top__rightcontent a {\n  text-decoration: none;\n  color: #cd1479;\n  font-weight: 500;\n}\n.signin__right__form {\n  width: 40%;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 4vmin;\n}\n.signin__right__form__topcontent {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n.signin__right__form__topcontent div:nth-child(1) {\n  font-size: 24px;\n  font-weight: 700;\n  color: #150648;\n}\n.signin__right__form__topcontent div:nth-child(2) {\n  font-weight: normal;\n  font-size: 14px;\n  color: #667085;\n}\n.signin__right__form__topcontent div:nth-child(3) {\n  margin-top: 5px;\n  width: 48px;\n  height: 8px;\n  background-color: #007364;\n}\n.signin__right__form__logingooglebtn {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.signin__right__form__logingooglebtn__btn {\n  cursor: pointer;\n  max-width: 100%;\n  min-width: 100%;\n  padding: 8px 16px;\n  border: 1px solid #9999b9;\n  background-color: #ffffff;\n  display: flex;\n  justify-content: space-between;\n}\n.signin__right__form__logingooglebtn__btn div:nth-child(2) {\n  color: #03014c;\n  font-size: 16px;\n}\n.signin__right__form__logingooglebtn__btn div:last-child {\n  visibility: hidden;\n}\n.signin__right__form__logingooglebtn__content {\n  font-size: 14px;\n  font-weight: 500;\n}\n.signin__right__form__input-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  width: 100%;\n}\n.signin__right__form__input-fields__input-item {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.signin__right__form__input-fields__input-item__labeldiv {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.signin__right__form__input-fields__input-item__labeldiv div:nth-child(1) {\n  font-size: 14px;\n  color: #150648;\n  font-weight: 500;\n}\n.signin__right__form__input-fields__input-item__labeldiv div:nth-child(2) {\n  font-size: 13px;\n  color: #667085;\n}\n.signin__right__form__input-fields__input-item label {\n  font-size: 14px;\n  color: #150648;\n  font-weight: 500;\n}\n.signin__right__form__input-fields__input-item input {\n  width: 100%;\n  background-color: #ffffff;\n  border: 1px solid #9999b9;\n  padding: 8px 16px;\n}\n.signin__right__form__input-fields__input-item input ::-moz-placeholder {\n  color: #667085;\n}\n.signin__right__form__input-fields__input-item input ::placeholder {\n  color: #667085;\n}\n.signin__right__form__input-fields__input-item input:focus {\n  outline: none;\n}\n.signin__right__form__input-fields__input-item-password {\n  position: relative;\n}\n.signin__right__form__input-fields__input-item-password-input {\n  padding-right: 30px;\n}\n.signin__right__form__input-fields__input-item-password-icon {\n  position: absolute;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n}\n.signin__right__form__signinbtn {\n  width: 100%;\n  padding-top: 10px;\n}\n.signin__right__form__signinbtn button {\n  text-align: center;\n  width: 100%;\n  background-color: #dd4498;\n  color: #ffffff;\n  border-radius: 5px;\n  border: none;\n  cursor: pointer;\n  padding: 12px 0;\n}\n.signin__bottom {\n  display: flex;\n  color: #667085;\n  justify-content: flex-end;\n  padding-top: 4vh;\n}\n/* sign in style */\n\n/* sign up style */\n.signup {\n  width: 100%;\n  height: 100%;\n  display: flex;\n}\n.signup__leftimg {\n  width: 35%;\n  min-width: 500px;\n  height: 100%;\n  position: relative;\n}\n.signup__leftimg__img {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  z-index: 1;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n.signup__leftimg__img-cover {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  z-index: 99;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n.signup__leftimg__textcontainer {\n  position: absolute;\n  z-index: 100;\n  bottom: 23%;\n  color: #ffffff;\n  width: 100%;\n  padding: 0 4vw;\n  display: flex;\n  flex-direction: column;\n  gap: 2vw;\n}\n.signup__leftimg__textcontainer div {\n  line-height: 35.5px;\n}\n.signup__leftimg__textcontainer__heading {\n  font-size: 2.3vw;\n  font-weight: bolder;\n}\n.signup__leftimg__textcontainer__content {\n  font-size: 1.05vw;\n  font-weight: normal;\n}\n.signup__right {\n  width: 75%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 10vmin;\n  padding: 2.2vw 4vw;\n  overflow: hidden;\n}\n.signup__right__top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.signup__right__top__btn {\n  text-decoration: none;\n  background-color: #eff1f4;\n  color: #cd1479;\n  font-size: 14px;\n  font-weight: 600;\n  display: flex;\n  gap: 0.75vw;\n  align-items: center;\n  padding: 9px 12px;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n}\n.signup__right__top__rightcontent {\n  font-size: 14px;\n}\n.signup__right__top__rightcontent a {\n  text-decoration: none;\n  color: #cd1479;\n  font-weight: 500;\n}\n.signup__right__form {\n  width: 40%;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 2.2vmin;\n}\n.signup__right__form__topcontent {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n.signup__right__form__topcontent div:nth-child(1) {\n  font-size: 24px;\n  font-weight: 700;\n  color: #150648;\n}\n.signup__right__form__topcontent div:nth-child(2) {\n  font-weight: normal;\n  font-size: 14px;\n  color: #667085;\n}\n.signup__right__form__topcontent div:nth-child(3) {\n  margin-top: 5px;\n  width: 48px;\n  height: 8px;\n  background-color: #007364;\n}\n.signup__right__form__logingooglebtn {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.signup__right__form__logingooglebtn__btn {\n  cursor: pointer;\n  max-width: 100%;\n  min-width: 100%;\n  padding: 10px 16px;\n  border: 1px solid #9999b9;\n  background-color: #ffffff;\n  display: flex;\n  justify-content: space-between;\n}\n.signup__right__form__logingooglebtn__btn div:nth-child(2) {\n  color: #03014c;\n  font-size: 16px;\n}\n.signup__right__form__logingooglebtn__btn div:last-child {\n  visibility: hidden;\n}\n.signup__right__form__logingooglebtn__content {\n  font-size: 14px;\n  font-weight: 500;\n}\n.signup__right__form__input-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 0.8rem;\n  width: 100%;\n}\n.signup__right__form__input-fields__input-item {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.signup__right__form__input-fields__input-item label {\n  font-size: 14px;\n  color: #150648;\n  font-weight: 500;\n}\n.signup__right__form__input-fields__input-item input {\n  width: 100%;\n  background-color: #ffffff;\n  border: 1px solid #9999b9;\n  padding: 10px 16px;\n}\n.signup__right__form__input-fields__input-item input ::-moz-placeholder {\n  color: #667085;\n}\n.signup__right__form__input-fields__input-item input ::placeholder {\n  color: #667085;\n}\n.signup__right__form__input-fields__input-item input:focus {\n  outline: none;\n}\n.signup__right__form__signupbtn {\n  width: 100%;\n  padding-top: 10px;\n}\n.signup__right__form__signupbtn button {\n  text-align: center;\n  width: 100%;\n  background-color: #dd4498;\n  color: #ffffff;\n  border-radius: 5px;\n  border: none;\n  cursor: pointer;\n  padding: 12px 0;\n}\n\n.password-field {\n  position: relative;\n}\n\n.password-input-container {\n  position: relative;\n}\n\n.password-input {\n  width: 100%;\n  background-color: #ffffff;\n  border: 1px solid #9999b9;\n  padding: 10px 16px;\n}\n.password-input ::-moz-placeholder {\n  color: #667085;\n}\n.password-input ::placeholder {\n  color: #667085;\n}\n.password-input:focus {\n  outline: none;\n}\n\n.password-icon {\n  position: absolute;\n  top: 70%;\n  right: 10px;\n  transform: translateY(-50%);\n}\n/* sign up style */\n\n/* navbar Style */\n.header__navbar {\n  width: 100%;\n  background-color: #ffffff;\n  height: 10vh;\n  position: sticky;\n  top: 0;\n  z-index: 999;\n  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.1);\n}\n\n.webbie_container {\n  width: 95%;\n  height: 100%;\n  margin: 0 auto;\n  padding: 1vh 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.header_logo img {\n  width: 180px;\n}\n.webbie_container_container__navitems {\n  display: flex;\n  gap: 2vw;\n  list-style: none;\n  align-items: center;\n}\n.webbie_container_container__navitems li a {\n  cursor: pointer;\n  color: #000000;\n  font-size: 1vw;\n  font-weight: 700;\n  text-decoration: none;\n}\n.homepage__navbar__container__navitems_login {\n  display: flex;\n  gap: 2vw;\n  align-items: center;\n}\n.homepage__navbar__container__navitems_login div a {\n  cursor: pointer;\n  font-weight: 500;\n  color: #000000;\n  font-size: 1vw;\n  font-weight: 700;\n  text-decoration: none;\n}\n.homepage__navbar__container__navitems_login div:nth-child(2) {\n  background-color: #dd4498;\n  padding: 0.65vw 1vw;\n  border-radius: 0.5vw;\n  cursor: pointer;\n}\n.homepage__navbar__container__navitems_login div:nth-child(2) a {\n  cursor: pointer;\n  color: #ffffff;\n  font-weight: 500;\n}\n.homepage__navbar__hamburger {\n  display: none;\n}\n.homepage__navbar__hamburger-menu {\n  display: none;\n  z-index: 999;\n  border-top: 2px solid #688ad5 !important;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  background-color: #ffffff;\n  width: 100%;\n  padding: 1rem;\n  border: 1px solid #ddd;\n  border-top: none;\n}\n.homepage__navbar__hamburger-menu.show {\n  display: block;\n}\n.homepage__navbar__hamburger-menu ul {\n  list-style: none;\n  padding: 0;\n}\n.homepage__navbar__hamburger-menu ul li {\n  margin-bottom: 1rem;\n}\n.homepage__navbar__hamburger-menu ul li a {\n  color: #000000;\n  text-decoration: none;\n  font-size: 1rem;\n  font-weight: 500;\n}\n\n/* Homepage Style */\n.homepage {\n  width: 100%;\n}\n.hero {\n  width: 100%;\n  height: 60vh;\n}\n.hero__herosection {\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n.hero__herosection__img1 {\n  position: absolute;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n.hero__herosection__img2 {\n  position: absolute;\n  z-index: 2;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n.hero__content {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  z-index: 99;\n}\n.hero__content__div {\n  height: 100%;\n  width: 80%;\n  margin: 0 auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.hero__content__div__text {\n  width: 45%;\n  height: 50%;\n  margin: auto 0;\n  display: flex;\n  flex-direction: column;\n  /* justify-content: space-between; */\n  gap: 1rem;\n}\n\n.hero__content__div__text__heading {\n  color: #ffffff;\n  font-size: var(--hero-font);\n  font-weight: bolder;\n}\n.hero__content__div__text__content {\n  font-size: 1.1vw;\n  color: #ffffff;\n  font-weight: 500;\n  width: 100%;\n}\n.hero__content__div__text__button {\n  padding-top: 3vh;\n}\n.hero__content__div__text__button a {\n  cursor: pointer;\n  border: none;\n  border-radius: 6px;\n  font-size: 1vw;\n  padding: 0.75vw 1vw;\n  color: #000000;\n  background-color: #f3f2f2;\n  text-decoration: none;\n}\n.hero__content__div__image {\n  width: 40%;\n}\n.hero__content__div__image img {\n  width: 100%;\n}\n.homepage__bussinessbox {\n  width: 100%;\n}\n.homepage__bussinessbox__container {\n  width: 80%;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  gap: 1vw;\n  padding: 3vmin 0;\n}\n.homepage__bussinessbox__container__img1,\n.homepage__bussinessbox__container__img2,\n.homepage__bussinessbox__container__img3 {\n  width: 25%;\n}\n.homepage__bussinessbox__container__img1__div,\n.homepage__bussinessbox__container__img2__div,\n.homepage__bussinessbox__container__img3__div {\n  width: 80%;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75vw;\n  justify-content: center;\n}\n.homepage__bussinessbox__container__img1__div img,\n.homepage__bussinessbox__container__img2__div img,\n.homepage__bussinessbox__container__img3__div img {\n  width: 100%;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n.homepage__bussinessbox__container__img1__div div,\n.homepage__bussinessbox__container__img2__div div,\n.homepage__bussinessbox__container__img3__div div {\n  text-align: center;\n  font-size: 1.5vw;\n  font-weight: 800;\n  color: #001d7d;\n}\n.homepage__bussinessbox__container__plus,\n.homepage__bussinessbox__container__equal {\n  width: 3%;\n  font-family: \"Qwitcher Grypen\", cursive;\n  font-size: 6vw;\n  color: #001d7d;\n}\n\n.homepage__bussinessbox__container__text {\n  width: 17%;\n  height: 100%;\n  padding-left: 1vw;\n}\n.homepage__bussinessbox__container__text span {\n  font-size: 32px;\n  color: #001d7d;\n  font-weight: 900;\n}\n.homepage__bsimplified {\n  width: 100%;\n  background-color: #f8fafc;\n}\n.homepage__bsimplified__container {\n  width: 80%;\n  margin: 0 auto;\n  padding: 4vmax 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.homepage__bsimplified__container__content {\n  width: 40%;\n  display: flex;\n  flex-direction: column;\n  gap: 3vh;\n}\n.homepage__bsimplified__container__content__heading {\n  font-size: var(--section-heading-font);\n  font-weight: bolder;\n  color: #000000;\n}\n.homepage__bsimplified__container__content__list {\n  display: flex;\n  flex-direction: column;\n  gap: 2vh;\n}\n.homepage__bsimplified__container__content__list li {\n  display: flex;\n  align-items: center;\n  gap: 1vw;\n}\n.homepage__bsimplified__container__content__list li span {\n  font-size: 1.1vw;\n  color: #625d5d;\n}\n.homepage__bsimplified__container__content__signupbtn {\n  display: flex;\n  align-items: center;\n  padding: 0.5vw 0;\n}\n.homepage__bsimplified__container__content__signupbtn a {\n  display: flex;\n  align-items: center;\n  gap: 0.75vw;\n  text-decoration: none;\n  height: 100%;\n  padding: 10px 20px;\n  border: 1px solid #688ad5;\n  border-radius: 6px;\n}\n.homepage__bsimplified__container__content__signupbtn a span {\n  text-decoration: none;\n  font-size: 1.1vw;\n  color: #688ad5;\n}\n.homepage__bsimplified__container__content__signupbtn a span img {\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n.homepage__bsimplified__right {\n  width: 50%;\n}\n.homepage__bsimplified__right img {\n  width: 100%;\n}\n.homepage__bottomPart {\n  width: 100%;\n  background-color: #ffffff;\n  display: flex;\n  flex-direction: column;\n  gap: 4vmax;\n  height: 75vh;\n  padding: 5vh 0;\n}\n.homepage__bottomPart__businessgrow {\n  width: 80%;\n  margin: 0 auto;\n  display: flex;\n  justify-content: space-between;\n  position: relative;\n  height: 90%;\n}\n.homepage__bottomPart__businessgrow__image {\n  height: 100%;\n  width: 35%;\n  position: absolute;\n  top: 0;\n  z-index: 1;\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 10px;\n  border-radius: 8px;\n}\n.homepage__bottomPart__businessgrow__image img {\n  -o-object-fit: cover;\n  object-fit: cover;\n  width: 100%;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n}\n.homepage__bottomPart__businessgrow__image__topcontent {\n  position: absolute;\n  top: 10%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 15px;\n  z-index: 3;\n}\n.homepage__bottomPart__businessgrow__image__topcontent div {\n  text-align: center;\n  width: 100%;\n}\n.homepage__bottomPart__businessgrow__image__topcontent div:nth-child(1) {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n.homepage__bottomPart__businessgrow__image__topcontent div:nth-child(1) img {\n  width: 40px;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n.homepage__bottomPart__businessgrow__image__topcontent div:nth-child(2) {\n  width: 80%;\n  margin: 0 auto;\n}\n.homepage__bottomPart__businessgrow__image__topcontent div:nth-child(2) img {\n  width: 70%;\n}\n.homepage__bottomPart__businessgrow__image__topcontent div:nth-child(3) {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n.homepage__bottomPart__businessgrow__image__topcontent\n  div:nth-child(3)\n  span:nth-child(1) {\n  text-shadow: 1px 0 #000000;\n  letter-spacing: 1px;\n  color: #000000;\n  font-size: var(--section-heading-font);\n  font-weight: 900;\n}\n.homepage__bottomPart__businessgrow__image__topcontent\n  div:nth-child(3)\n  span:nth-child(2) {\n  color: #000000;\n  font-size: 1.2vw;\n  font-weight: 700;\n}\n.homepage__bottomPart__businessgrow__image__topcontent div:nth-child(4) button {\n  border: none;\n  background-color: #ee3572;\n  color: #ffffff;\n  font-size: 1.35vw;\n  font-weight: 700;\n  padding: 0.75vw 2vw;\n  border-radius: 5px;\n  cursor: pointer;\n}\n.homepage__bottomPart__businessgrow__image__topcontent div:nth-child(5) {\n  width: 80%;\n  margin: 0 auto;\n}\n.homepage__bottomPart__businessgrow__image__topcontent div:nth-child(5) p {\n  font-size: 1vw;\n  padding: 1vw;\n  color: #7d7878;\n  border: 1.5px dashed #7d7878;\n}\n.homepage__bottomPart__businessgrow__right {\n  width: 40%;\n  position: absolute;\n  right: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10%;\n  height: 100%;\n  justify-content: center;\n}\n.homepage__bottomPart__businessgrow__right__content {\n  display: flex;\n  flex-direction: column;\n}\n.homepage__bottomPart__businessgrow__right__content {\n  font-size: var(--section-heading-font);\n  font-weight: 900;\n}\n.homepage__partners {\n  width: 100%;\n  background-color: #ffffff;\n  gap: 2vh;\n  padding: 4vmin 0;\n}\n.homepage__partners__div {\n  width: 80%;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 3vmax;\n}\n.homepage__partners__div__head {\n  display: flex;\n  gap: 5%;\n  align-items: center;\n}\n.homepage__partners__div__head span:nth-child(1),\n.homepage__partners__div__head span:nth-child(3) {\n  height: 2px;\n  background-color: #000000;\n  width: 27%;\n}\n.homepage__partners__div__head span:nth-child(2) {\n  font-size: 2vw;\n  font-weight: 600;\n  color: #000000;\n}\n.homepage__partners__div__brandlogos {\n  display: flex;\n  align-items: center;\n  /* gap: 10%; */\n}\n.homepage__partners__div__brandlogos__c1 {\n  width: 50%;\n  display: flex;\n  gap: 15%;\n  align-items: center;\n}\n\n.homepage__support {\n  width: 100%;\n  background-color: #ffffff;\n}\n.homepage__support__div {\n  width: 80%;\n  height: 90%;\n  margin: 0 auto;\n  padding: 3vmax 0;\n  display: flex;\n  justify-content: space-between;\n}\n.homepage__support__div__card {\n  display: flex;\n  flex-direction: column;\n  gap: 2vmax;\n  width: 28%;\n  padding: 2vw;\n  border-radius: 10px;\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 10px;\n}\n.homepage__support__div__card__image {\n  position: relative;\n  z-index: 1;\n}\n.homepage__support__div__card__image .roundshape {\n  left: 0;\n  height: 35px;\n  width: 35px;\n  background-color: rgba(204, 55, 144, 0.2666666667);\n  border-radius: 50%;\n  position: absolute;\n  z-index: 99;\n  top: 31px;\n  left: -6px;\n}\n.homepage__support__div__card__image img {\n  height: 60px;\n  width: 60px;\n}\n.homepage__support__div__card__content {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5vw;\n}\n.homepage__support__div__card__content div:nth-child(1) {\n  font-size: 1vw;\n  font-weight: 700;\n  color: #1e1d1d;\n}\n.homepage__support__div__card__content div:nth-child(2) {\n  font-size: 1vw;\n  font-weight: 500;\n  color: #625d5d;\n}\n.homepage__support__div__card__nextbtn {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n}\n.homepage__support__div__card__nextbtn__imgdiv {\n  padding: 0 2.25vw;\n  background-color: #ffffff;\n  color: #688ad5;\n  font-size: 1.25vw;\n  border: 2px solid #688ad5;\n  border-radius: 2vw;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n/* homepage style */\n\n/* about style */\n.aboutpage {\n  width: 100%;\n}\n.aboutpage__container {\n  width: 80%;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 3vh;\n  position: relative;\n  z-index: 1;\n}\n.aboutpage__container__div {\n  width: 100%;\n  margin: 0 auto;\n  padding: 2vmin 0;\n}\n.aboutpage__container__div__para {\n  display: flex;\n  flex-direction: column;\n  gap: 3vmin;\n  padding: 2vmin 0;\n}\n.aboutpage__container__div__para p {\n  text-align: justify;\n  font-size: 16px;\n  font-weight: 500;\n}\n.aboutpage__container__trustdiv {\n  width: 100%;\n  margin: 0 auto;\n  display: flex;\n  justify-content: space-between;\n}\n.aboutpage__container__trustdiv__left {\n  width: 55%;\n  background-color: #688ad5;\n  padding: 2.5vw 2vw;\n  display: flex;\n  flex-direction: column;\n  gap: 2vmax;\n  border-radius: 1vw;\n}\n.aboutpage__container__trustdiv__left__title {\n  font-size: var(--section-heading-font);\n  font-weight: 900;\n  display: flex;\n  color: #ffffff;\n  flex-direction: column;\n  align-items: center;\n}\n.aboutpage__container__trustdiv__left__images {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 2vmax;\n}\n.aboutpage__container__trustdiv__left__images__top {\n  display: flex;\n  width: 100%;\n  gap: 2.5vw;\n  align-items: center;\n  justify-content: center;\n}\n.aboutpage__container__trustdiv__left__images__top div {\n  width: 30%;\n}\n.aboutpage__container__trustdiv__left__images__top div img {\n  width: 100%;\n  -o-object-fit: scale-down;\n  object-fit: scale-down;\n}\n.aboutpage__container__trustdiv__right {\n  border-radius: 1vw;\n  width: 40%;\n  padding: 2.5vw 2vw;\n  background-color: #dd4498;\n  display: flex;\n  flex-direction: column;\n  gap: 2.5vmax;\n  align-items: center;\n}\n.aboutpage__container__trustdiv__right__nextbtn {\n  width: 100%;\n}\n.aboutpage__container__trustdiv__right__nextbtn__imgdiv {\n  width: 35px;\n  height: 35px;\n  background-color: #ffffff;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  padding: 1.75vw;\n}\n.aboutpage__container__trustdiv__right div {\n  font-size: var(--section-heading-font);\n  font-weight: 900;\n  color: #ffffff;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.aboutpage__container__welcomediv {\n  width: 80%;\n  margin: 0 auto;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  gap: 2vmax;\n  padding: 4vmax 0;\n}\n.aboutpage__container__welcomediv div:nth-child(1) {\n  font-size: var(--section-heading-font);\n  font-weight: 900;\n}\n.aboutpage__container__welcomediv div:nth-child(2) {\n  display: flex;\n  justify-content: space-evenly;\n}\n.aboutpage__container__welcomediv div:nth-child(2) div {\n  padding: 15px 0px;\n  font-size: 16px;\n  width: 30%;\n  background-color: #f1ebff;\n  font-weight: 700;\n  border-radius: 10px;\n}\n.aboutpage__container__support {\n  width: 80%;\n  height: 90%;\n  margin: 0 auto;\n  background-color: #ffffff;\n  padding: 0 0 2vw 0;\n}\n/* about style */\n\n/* contact style */\n\n.contactuspage {\n  width: 100%;\n}\n.contactuspage__container {\n  width: 80%;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 3vh;\n  position: relative;\n  z-index: 1;\n}\n.contactuspage__container__div {\n  width: 100%;\n  margin: 0 auto;\n  padding: 2vmin 0;\n}\n.contactuspage__container__div__para__form {\n  width: 100%;\n  background-color: #ffffff;\n}\n\n.contactuspage__container__div__para__form__container {\n  width: 70%;\n  margin: 0 auto;\n}\n\n.contactuspage__container__div__para__form__container .heading {\n  color: #000000;\n  font-size: var(--section-heading-font);\n  font-weight: 500;\n  padding: 1vw 0;\n  text-align: center;\n}\n\n.contact__form {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 2vw;\n}\n\n.contact__form__inputfield {\n  width: 80%;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin: 0 auto;\n}\n\n.contact__form__label {\n  color: #7369ab;\n  font-size: 1vw;\n}\n.contact__form__inputfield input,\nselect {\n  display: block;\n  border: 1px solid #e5e9f5;\n  background-color: #f6f7fa;\n  padding: 1vw 1.5vw;\n  width: 100%;\n}\n.contact__form__inputfield select {\n  font-size: 12px;\n}\n\n.contact__form__inputfield input::placeholder {\n  font-size: 1vw;\n}\n\n.contact__form__contactemail {\n  display: flex;\n  width: 80%;\n  margin: 0 auto;\n  justify-content: space-between;\n}\n\n.contact__form__contactemail div {\n  width: 48%;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.contact__form__contactemail div input {\n  display: block;\n  border: 1px solid #e5e9f5;\n  background-color: #f6f7fa;\n  padding: 1vw 1.5vw;\n  width: 100%;\n}\n\n.contact__form__contactemail div input::placeholder {\n  font-size: 12px;\n}\n\n#contact__form__inputfield__button {\n  width: 100%;\n}\n.contact__form__button__submit {\n  margin-left: 10%;\n  margin-top: 5px;\n  padding: 0.65vw 2vw;\n  background-color: #dd4498;\n  border-radius: 5px;\n  color: white;\n  font-size: 1.25vw;\n  border: none;\n}\n\n.contactuspage__container__welcomediv {\n  width: 100%;\n  margin: 0 auto;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  gap: 2vmax;\n  padding: 1vmax 0;\n}\n.contactuspage__container__welcomediv__title {\n  font-size: var(--section-heading-font);\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.contactuspage__container__welcomediv__title span:nth-child(1),\n.contactuspage__container__welcomediv__title span:nth-child(3) {\n  width: 30%;\n  height: 1px;\n  background: #000;\n}\n.contactuspage__container__welcomediv__div1,\n.contactuspage__container__welcomediv__div2 {\n  display: flex;\n  justify-content: space-evenly;\n}\n.contactuspage__container__welcomediv__div1 div,\n.contactuspage__container__welcomediv__div2 div {\n  padding: 15px 0px;\n  font-size: 16px;\n  width: 30%;\n  background-color: #f1ebff;\n  font-weight: 700;\n  border-radius: 10px;\n}\n\n/* contact style */\n\n/* payments style */\n\n.payments__container {\n  width: 80%;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 3vh;\n}\n.payments__container__toppart {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 2.5vmax 0;\n}\n.payments__container__toppart__heading {\n  font-size: var(--section-heading-font);\n  font-weight: 500;\n  letter-spacing: 1px;\n  padding-bottom: 2vmax;\n  margin-bottom: 3vw;\n}\n.payments__container__toppart__box {\n  display: flex;\n  flex-direction: column;\n  gap: 6vmax;\n  width: 100%;\n}\n.payments__container__toppart__box__content {\n  width: 100%;\n  display: flex;\n  justify-content: space-evenly;\n}\n.payments__container__toppart__box__content__div {\n  width: 40%;\n  height: 20vh;\n  min-height: 200px;\n  position: relative;\n}\n.payments__container__toppart__box__content__div .bg {\n  width: 100%;\n  height: 35vh;\n  min-height: 200px;\n  position: absolute;\n  z-index: 1;\n  background: #ebedf0;\n  top: -16%;\n  right: 6%;\n  border-radius: 1vw;\n}\n.payments__container__toppart__box__content__div__wrapper {\n  position: absolute;\n  padding: 2vw;\n  width: 100%;\n  height: 100%;\n  min-height: 200px;\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 1vh;\n  z-index: 99;\n  background-color: #ffffff;\n  border-radius: 1vw;\n}\n.payments__container__toppart__box__content__div__wrapper .heading {\n  font-size: 16px;\n  font-weight: 700;\n}\n.payments__container__toppart__box__content__div__wrapper .text {\n  padding-top: 20px;\n  font-size: 14px;\n}\n.payments__container__partners {\n  width: 100%;\n  background-color: #ffffff;\n  gap: 2vh;\n  padding: 4vmin 0;\n}\n.payments__container__partners__div {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 3vmax;\n}\n.payments__container__partners__div__button {\n  width: 100%;\n  text-align: center;\n}\n.payments__container__partners__div__button a {\n  font-size: 1.25vw;\n  color: #ffffff;\n  text-decoration: none;\n  background-color: #dd4498;\n  padding: 1vw 2vw;\n  border-radius: 0.5vw;\n  cursor: pointer;\n  border: none;\n}\n.payments__container__partners__div__head {\n  display: flex;\n  gap: 5%;\n  align-items: center;\n}\n.payments__container__partners__div__head span:nth-child(1),\n.payments__container__partners__div__head span:nth-child(3) {\n  height: 2px;\n  background-color: #000000;\n  width: 27%;\n}\n.payments__container__partners__div__head span:nth-child(2) {\n  font-size: var(--section-heading-font);\n  font-weight: 600;\n  color: #000000;\n}\n.payments__container__partners__div__brandlogos {\n  display: flex;\n  gap: 10%;\n  align-items: center;\n}\n.payments__container__partners__div__brandlogos div img {\n  width: 100%;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n/* payments style */\n\n/* partners style */\n\n.partnerspage {\n  width: 100%;\n}\n.partnerspage__hero {\n  width: 100%;\n  height: 60vh;\n}\n.partnerspage__hero__herosection {\n  width: 100%;\n  height: 100%;\n  /* background: url(\"../images/homebanner-bg-1.svg\"); */\n}\n.partnerspage__hero__content {\n  width: 100%;\n  height: 100%;\n}\n.partnerspage__hero__content__div {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.partnerspage__hero__content__div__left {\n  width: 50%;\n  height: 100%;\n  margin: auto 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 2vmax;\n  /* background: url(\"../images/partners-hero-right-bg.svg\"); */\n}\n.partnerspage__hero__content__div__left__text {\n  padding-left: 20%;\n}\n.partnerspage__hero__content__div__left__text__heading {\n  color: #ffffff;\n  font-size: var(--hero-font);\n  font-weight: 1000;\n}\n.partnerspage__hero__content__div__left__text__content {\n  color: #ffffff;\n  width: 70%;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5vw;\n}\n.partnerspage__hero__content__div__left__text__content__top {\n  font-size: 1.1vw;\n  font-weight: 700;\n}\n.partnerspage__hero__content__div__left__text__button {\n  padding-top: 2vh;\n}\n.partnerspage__hero__content__div__left__text__button a {\n  cursor: pointer;\n  border: none;\n  border-radius: 5px;\n  font-size: 1vw;\n  padding: 0.75vw 1vw;\n  text-decoration: none;\n  color: #000000;\n  background-color: #f3f2f2;\n}\n.partnerspage__hero__content__div__image {\n  width: 50%;\n  height: 100%;\n}\n.partnerspage__hero__content__div__image img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n.partnerspage__container {\n  width: 80%;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 3vh;\n  position: relative;\n  z-index: 1;\n}\n.partnerspage__container__div {\n  width: 100%;\n  margin: 0 auto;\n  padding: 2vmin 0;\n}\n.partnerspage__container__div__para {\n  display: flex;\n  padding: 2vmin 0;\n  justify-content: space-between;\n  align-items: center;\n}\n.partnerspage__container__div__para__equal {\n  width: 3%;\n  font-family: \"Qwitcher Grypen\", cursive;\n  font-size: 7vw;\n  color: #001d7d;\n}\n.partnerspage__container__div__para__box {\n  width: 28%;\n}\n.partnerspage__container__div__para__box img {\n  width: 100%;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n\n.partnerspage__container__welcomediv {\n  width: 100%;\n  margin: 0 auto;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  gap: 2vmax;\n  padding: 1vmax 0;\n}\n.partnerspage__container__welcomediv__title {\n  font-size: var(--section-heading-font);\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.partnerspage__container__welcomediv__title span:nth-child(1),\n.partnerspage__container__welcomediv__title span:nth-child(3) {\n  width: 30%;\n  height: 1px;\n  background: #000;\n}\n.partnerspage__container__welcomediv__div1,\n.partnerspage__container__welcomediv__div2 {\n  display: flex;\n  justify-content: space-evenly;\n}\n.partnerspage__container__welcomediv__div1 div,\n.partnerspage__container__welcomediv__div2 div {\n  padding: 12px 0px;\n  font-size: 20px;\n  width: 30%;\n  background-color: #f1ebff;\n  font-weight: 600;\n  border-radius: 6px;\n}\n\n/* partners style */\n\n/* shipping style  */\n.shipping {\n  width: 100%;\n}\n.shipping__container {\n  width: 80%;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 3vh;\n}\n.shipping__container__toppart {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 2.5vmax 0;\n}\n.shipping__container__toppart__heading {\n  font-size: var(--section-heading-font);\n  font-weight: 500;\n  letter-spacing: 1px;\n  padding-bottom: 2vmax;\n  margin-bottom: 3vw;\n}\n.shipping__container__toppart__box {\n  display: flex;\n  flex-direction: column;\n  gap: 3vmax;\n  width: 100%;\n}\n.shipping__container__toppart__box__content {\n  width: 100%;\n  display: flex;\n  justify-content: space-evenly;\n}\n.shipping__container__toppart__box__content__div {\n  width: 30%;\n  height: 30vh;\n  min-height: 280px;\n  position: relative;\n}\n.shipping__container__toppart__box__content__div .bg {\n  width: 100%;\n  height: 30vh;\n  min-height: 280px;\n  position: absolute;\n  z-index: 1;\n  background: #ebedf0;\n  top: 8%;\n  right: -4%;\n  border-radius: 1vw;\n}\n.shipping__container__toppart__box__content__div__wrapper {\n  position: absolute;\n  padding: 2vw;\n  width: 100%;\n  height: 100%;\n  min-height: 280px;\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 1vh;\n  z-index: 99;\n  background-color: #ffffff;\n  border-radius: 1vw;\n}\n.shipping__container__toppart__box__content__div__wrapper .heading {\n  font-size: 16px;\n  font-weight: 700;\n  min-height: 40px;\n}\n.shipping__container__toppart__box__content__div__wrapper .text {\n  font-size: 14px;\n}\n\n/* shipping style */\n\n/* footer Style */\n\n.footer {\n  width: 100%;\n  background: #1e1d1d;\n}\n.footer__div {\n  width: 80%;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  padding: 1vw 0;\n}\n.footer__div__top {\n  display: flex;\n  justify-content: space-between;\n  padding: 2vw 0;\n}\n.footer__div__top__aboutus {\n  width: 30%;\n  display: flex;\n  flex-direction: column;\n  gap: 1vw;\n  color: #ffffff;\n}\n.footer__div__top__aboutus div:nth-child(1) {\n  font-size: 1vw;\n  font-weight: bolder;\n}\n.footer__div__top__aboutus div:nth-child(2) {\n  font-size: 1vw;\n  font-weight: 300;\n}\n.footer__div__top__aboutus div:nth-child(3) {\n  font-size: 1.25vw;\n  display: flex;\n  gap: 12px;\n}\n.footer__div__top__aboutus div:nth-child(3) a {\n  color: #ffffff;\n}\n.footer__div__top__right {\n  width: 30%;\n  display: flex;\n  justify-content: space-between;\n  padding-left: 60px;\n}\n.footer__div__top__right__notifications {\n  width: 70%;\n  display: flex;\n  list-style: none;\n  flex-direction: column;\n  gap: 3px;\n  font-size: 1vw;\n  color: #ffffff;\n  font-weight: bolder;\n}\n\n.footer__div__top__right__notifications__heading {\n  border-bottom: 1px solid white;\n  width: fit-content;\n  margin-bottom: 3px;\n}\n\n.footer__div__top__right__notifications li a {\n  font-size: 12px;\n  text-decoration: none;\n  color: #ffffff;\n  font-weight: 500;\n}\n.footer__div__top__right__form {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 10px;\n  align-content: flex-end;\n}\n.footer__div__top__right__form input {\n  width: 100%;\n  padding: 0.75vw 0.75vw;\n  border-radius: 0.5vw;\n  border: none;\n}\n.footer__div__top__right__form input :focus {\n  outline: none;\n}\n.footer__div__top__right__form button {\n  width: 100%;\n  background-color: #dd4498;\n  color: #ffffff;\n  font-size: 1.25vw;\n  padding: 0.5vw 0;\n  border-radius: 0.5vw;\n  cursor: pointer;\n  border: none;\n}\n.footer__div__bottom {\n  width: 80%;\n  margin: 0 auto;\n  display: flex;\n  justify-content: space-between;\n  padding: 30px 0px;\n}\n.footer__div__bottom__left {\n  display: flex;\n  gap: 1vw;\n}\n.footer__div__bottom__left span {\n  color: #ffffff;\n  font-size: 1vw;\n}\n.footer__div__bottom__left span a {\n  font-size: 12px;\n  color: #ffffff;\n  text-decoration: none;\n}\n.footer__div__bottom__right {\n  color: #ffffff;\n  font-size: 12px;\n}\n.footer__div__line {\n  width: 100%;\n  height: 1px;\n  background-color: #5a5252;\n}\n/* footer style */\n\n/* Pricing Style */\n.pricing {\n  width: 100%;\n}\n.pricing__container {\n  width: 90%;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 2vmax 0;\n}\n.pricing__container__heading {\n  font-size: 1.5vw;\n  font-weight: 500;\n}\n.pricing__container__content {\n  font-size: 16px;\n  text-align: justify;\n}\n.pricing__container__subscribe {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n}\n.pricing__container__subscribe__card {\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 10px;\n  border-radius: 8px;\n  width: 32%;\n  display: flex;\n  flex-direction: column;\n  padding: 2vw 1vw;\n  align-items: center;\n}\n.pricing__container__subscribe__card__image {\n  width: 100%;\n  height: 330px;\n}\n.pricing__container__subscribe__card__image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.pricing__container__subscribe__card__content {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5vw;\n}\n.pricing__container__subscribe__card__content .heading {\n  font-size: 1.75vw;\n  font-weight: 900;\n  text-align: center;\n}\n\n.pricing__container__subscribe__card__content .borderline {\n  width: 20%;\n  margin: 0 auto;\n  height: 2px;\n  background: black;\n}\n.pricing__container__subscribe__card__content .text {\n  font-size: 16px;\n  font-weight: 500;\n  max-height: 50px;\n  text-align: center;\n}\n.pricing__container__subscribe__card__content .buttondiv {\n  width: 100%;\n  text-align: center;\n  padding-top: 10px;\n}\n.pricing__container__subscribe__card__content .buttondiv button {\n  font-size: 16px;\n  background: #000;\n  border-radius: 8px;\n  padding: 0.75vw 1.5vw;\n  color: #ffffff;\n  font-weight: 700;\n  border: none;\n  cursor: pointer;\n}\n.pricing__container .modal-container {\n  display: none;\n  position: fixed;\n  z-index: 1000;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.5); /* Transparent black background */\n}\n\n/* Modal Content Styles */\n.pricing__container .modal-container .modal-content {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  gap: 20px;\n  position: absolute;\n  background-color: #ffffffab;\n  padding: 10px;\n  border-radius: 10px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5); /* Shadow effect */\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.pricing__container .modal-container .modal-content .modal-text {\n  font-size: 40px;\n  font-weight: 900;\n}\n/* Close Icon Styles */\n.pricing__container .modal-container .modal-content .close-icon {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  cursor: pointer;\n  font-size: 96px;\n  color: red;\n}\n.pricing__container .image {\n  width: 300px;\n  height: 300px;\n}\n.pricing__container .image img {\n  width: 100%;\n  height: 100%;\n}\n/* Pricing Style */\n\n/* Terms Style */\n.terms {\n  width: 100%;\n}\n\n.terms__container {\n  width: 80%;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 10px 0 30px 0;\n}\n\n.terms__container__heading {\n  font-size: 48px;\n  font-weight: 900;\n}\n\n.terms__container__text {\n  font-size: 16px;\n}\n.terms__container__content {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.terms__container__content .heading {\n  font-size: 26px;\n  font-weight: 700;\n}\n.terms__container__content .text {\n  font-size: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n/* Terms Style */\n\n@media screen and (max-width: 768px) {\n  /* navbar style */\n  .webbie_container_container__navitems li a {\n    font-size: 1.55vw;\n  }\n  .homepage__navbar__container__navitems_login div a {\n    font-size: 1.55vw;\n  }\n  /* navbar style */\n\n  /* home style */\n  .homepage__navbar__container__navitems li a {\n    font-size: 1.55vw;\n  }\n  .homepage__navbar__container__navitems_login div a {\n    font-size: 1.55vw;\n  }\n  .hero {\n    height: 50vh;\n  }\n  .homepage__bottomPart {\n    height: 51vh;\n    gap: 2vmax;\n  }\n  .homepage__partners {\n    padding: 1vw 0;\n  }\n  /* home style */\n\n  /* about style */\n  .aboutpage__navbar__container__left__navitems li a {\n    font-size: 1.75vw;\n  }\n  .aboutpage__navbar__container__navitems_login div a {\n    font-size: 1.75vw;\n  }\n  .aboutpage__hero {\n    height: 55vh;\n  }\n  .aboutpage__hero__content__div__text {\n    width: 58%;\n  }\n  .aboutpage__hero__content__div__text__heading {\n    font-size: 5vw;\n  }\n  .aboutpage__hero__content__div__text__content__top,\n  .aboutpage__hero__content__div__text__content__bottom {\n    font-size: 1.75vw;\n  }\n  .aboutpage__hero__content__div__text__button button {\n    font-size: 1.75vw;\n  }\n  .aboutpage__hero__content__div__image {\n    width: 42%;\n  }\n  .aboutpage__container__div__para p {\n    font-size: 2vw;\n  }\n  .aboutpage__container__trustdiv {\n    width: 100%;\n  }\n  .aboutpage__container__trustdiv__left {\n    padding: 3.5vw 3vw;\n  }\n  .aboutpage__container__trustdiv__left__title {\n    font-size: 2.25vw;\n  }\n  .aboutpage__container__trustdiv__left__images__top div {\n    width: 40%;\n  }\n  .aboutpage__container__trustdiv__left__images__top div img {\n    -o-object-fit: cover;\n    object-fit: cover;\n  }\n  .aboutpage__container__trustdiv__right {\n    padding: 3.5vw 3vw;\n  }\n  .aboutpage__container__trustdiv__right div {\n    font-size: 2.25vw;\n  }\n  .aboutpage__container__welcomdiv div:nth-child(1) {\n    font-size: 2.25vw;\n  }\n  .aboutpage__container__welcomdiv div:nth-child(2) div {\n    font-size: 1.75vw;\n  }\n  .aboutpage__container__support__div__card {\n    justify-content: space-around;\n  }\n  .aboutpage__container__support__div__card img {\n    width: 60px;\n    height: 60px;\n  }\n  .aboutpage__container__support__div__card__content div:nth-child(1) {\n    font-size: 1.75vw;\n  }\n  .aboutpage__container__support__div__card__content div:nth-child(2) {\n    font-size: 1.5vw;\n  }\n  .aboutpage__container__support__div__card__nextbtn__imgdiv img {\n    width: 20px;\n    height: 20px;\n  }\n  .aboutpage__footer__div__top__aboutus {\n    width: 45%;\n  }\n  .aboutpage__footer__div__top__aboutus div:nth-child(1),\n  .aboutpage__footer__div__top__aboutus div:nth-child(2) {\n    font-size: 1.5vw;\n  }\n  .aboutpage__footer__div__top__right__notifications {\n    font-size: 1.5vw;\n  }\n  .aboutpage__footer__div__top__right__notifications li a {\n    font-size: 1.5vw;\n  }\n  .aboutpage__footer__div__top__right__form__heading {\n    font-size: 1.5vw;\n  }\n  .aboutpage__footer__div__top__right__form__button button {\n    font-size: 1.5vw;\n  }\n  .aboutpage__footer__div__bottom__left span {\n    font-size: 1.5vw;\n  }\n  .aboutpage__footer__div__bottom__left span a {\n    font-size: 1.5vw;\n  }\n  .aboutpage__footer__div__bottom__right {\n    font-size: 1.5vw;\n  }\n  /* about style */\n  .aboutpage__hero {\n    height: 45vh;\n  }\n  .aboutpage__hero__content__div__text {\n    width: 58%;\n  }\n  .aboutpage__hero__content__div__text__heading {\n    font-size: 5vw;\n  }\n  .aboutpage__hero__content__div__text__content {\n    width: 90%;\n  }\n  .aboutpage__hero__content__div__text__content__top,\n  .aboutpage__hero__content__div__text__content__bottom {\n    font-size: 1.75vw;\n  }\n  .aboutpage__hero__content__div__text__button button {\n    font-size: 1.75vw;\n  }\n  .aboutpage__hero__content__div__image {\n    width: 42%;\n  }\n  .aboutpage__container__div__para p {\n    font-size: 2vw;\n  }\n  .aboutpage__container__trustdiv {\n    width: 100%;\n  }\n  .aboutpage__container__trustdiv__left {\n    padding: 3.5vw 3vw;\n  }\n  .aboutpage__container__trustdiv__left__title {\n    font-size: 2.25vw;\n  }\n  .aboutpage__container__trustdiv__left__images__top div {\n    width: 40%;\n  }\n  .aboutpage__container__trustdiv__left__images__top div img {\n    -o-object-fit: cover;\n    object-fit: cover;\n  }\n  .aboutpage__container__trustdiv__right {\n    padding: 3.5vw 3vw;\n  }\n  .aboutpage__container__trustdiv__right div {\n    font-size: 2.25vw;\n  }\n  .aboutpage__container__welcomdiv div:nth-child(1) {\n    font-size: 2.25vw;\n  }\n  .aboutpage__container__welcomdiv div:nth-child(2) div {\n    font-size: 1.75vw;\n  }\n  .aboutpage__container__support__div__card {\n    justify-content: space-around;\n  }\n  .aboutpage__container__support__div__card img {\n    width: 60px;\n    height: 60px;\n  }\n  .aboutpage__container__support__div__card__content div:nth-child(1) {\n    font-size: 1.75vw;\n  }\n  .aboutpage__container__support__div__card__content div:nth-child(2) {\n    font-size: 1.5vw;\n  }\n  .aboutpage__container__support__div__card__nextbtn__imgdiv img {\n    width: 20px;\n    height: 20px;\n  }\n  /* about style */\n\n  /* contact style */\n\n  .contactuspage__hero {\n    height: 45vh;\n  }\n  .contactuspage__hero__content__div__text {\n    width: 58%;\n  }\n  .contactuspage__hero__content__div__text__heading {\n    font-size: 5vw;\n  }\n  .contactuspage__hero__content__div__text__content {\n    width: 90%;\n  }\n  .contactuspage__hero__content__div__text__content__top,\n  .contactuspage__hero__content__div__text__content__bottom {\n    font-size: 1.75vw;\n  }\n  .contactuspage__hero__content__div__text__button button {\n    font-size: 1.75vw;\n  }\n  .contactuspage__hero__content__div__image {\n    width: 42%;\n  }\n  .contactuspage__container__div__para p {\n    font-size: 2vw;\n  }\n  .contactuspage__container__trustdiv {\n    width: 100%;\n  }\n  .contactuspage__container__trustdiv__left {\n    padding: 3.5vw 3vw;\n  }\n  .contactuspage__container__trustdiv__left__title {\n    font-size: 2.25vw;\n  }\n  .contactuspage__container__trustdiv__left__images__top div {\n    width: 40%;\n  }\n  .contactuspage__container__trustdiv__left__images__top div img {\n    -o-object-fit: cover;\n    object-fit: cover;\n  }\n  .contactuspage__container__trustdiv__right {\n    padding: 3.5vw 3vw;\n  }\n  .contactuspage__container__trustdiv__right div {\n    font-size: 2.25vw;\n  }\n  .contactuspage__container__welcomdiv div:nth-child(1) {\n    font-size: 2.25vw;\n  }\n  .contactuspage__container__welcomdiv div:nth-child(2) div {\n    font-size: 1.75vw;\n  }\n  .contactuspage__container__support__div__card {\n    justify-content: space-around;\n  }\n  .contactuspage__container__support__div__card img {\n    width: 60px;\n    height: 60px;\n  }\n  .contactuspage__container__support__div__card__content div:nth-child(1) {\n    font-size: 1.75vw;\n  }\n  .contactuspage__container__support__div__card__content div:nth-child(2) {\n    font-size: 1.5vw;\n  }\n  .contactuspage__container__support__div__card__nextbtn__imgdiv img {\n    width: 20px;\n    height: 20px;\n  }\n  /* contact style */\n\n  /* payment style */\n  .payments__hero {\n    height: 45vh;\n  }\n  .payments__hero__content__div__text {\n    width: 58%;\n  }\n  .payments__hero__content__div__text__heading {\n    font-size: 4vw;\n  }\n  .payments__hero__content__div__text__content__top,\n  .payments__hero__content__div__text__content__bottom {\n    font-size: 1.75vw;\n  }\n  .payments__hero__content__div__text__button button {\n    font-size: 1.75vw;\n  }\n  .payments__hero__content__div__image {\n    width: 42%;\n  }\n  .payments__container__toppart__heading {\n    font-size: 3vw;\n    letter-spacing: 0;\n  }\n  .payments__container__toppart__box__content__div {\n    width: 40%;\n  }\n  .payments__container__toppart__box__content__div__wrapper {\n    top: 23px;\n  }\n  .payments__container__toppart__box__content__div__wrapper .heading {\n    font-size: 2.5vw;\n  }\n  .payments__container__toppart__box__content__div__wrapper .text {\n    font-size: 2vw;\n  }\n  .payments__container__toppart__box__content .bg {\n    top: 3%;\n    height: 35vh;\n  }\n  .payments__container__support__div__card {\n    justify-content: space-around;\n  }\n  .payments__container__support__div__card img {\n    width: 60px;\n    height: 60px;\n  }\n  .payments__container__support__div__card__content div:nth-child(1) {\n    font-size: 1.75vw;\n  }\n  .payments__container__support__div__card__content div:nth-child(2) {\n    font-size: 1.5vw;\n  }\n  .payments__container__support__div__card__nextbtn__imgdiv img {\n    width: 20px;\n    height: 20px;\n  }\n  /* payment style */\n\n  /* partners style */\n  .partnerspage__hero {\n    height: 45vh;\n  }\n  .partnerspage__hero__content__div__left {\n    width: 60%;\n  }\n  .partnerspage__hero__content__div__left__text {\n    padding-left: 10%;\n  }\n  .partnerspage__hero__content__div__left__text__heading {\n    font-size: 5vw;\n  }\n  .partnerspage__hero__content__div__left__text__content {\n    width: 90%;\n  }\n  .partnerspage__hero__content__div__left__text__content__top,\n  .partnerspage__hero__content__div__left__text__content__bottom {\n    font-size: 1.75vw;\n  }\n  .partnerspage__hero__content__div__left__text__button button {\n    font-size: 1.75vw;\n  }\n  .partnerspage__hero__content__div__image {\n    width: 40%;\n  }\n  .partnerspage__container__div__para p {\n    font-size: 2vw;\n  }\n  .partnerspage__container__trustdiv {\n    width: 100%;\n  }\n  .partnerspage__container__trustdiv__left {\n    padding: 3.5vw 3vw;\n  }\n  .partnerspage__container__trustdiv__left__title {\n    font-size: 2.25vw;\n  }\n  .partnerspage__container__trustdiv__left__images__top div {\n    width: 40%;\n  }\n  .partnerspage__container__trustdiv__left__images__top div img {\n    -o-object-fit: cover;\n    object-fit: cover;\n  }\n  .partnerspage__container__trustdiv__right {\n    padding: 3.5vw 3vw;\n  }\n  .partnerspage__container__trustdiv__right div {\n    font-size: 2.25vw;\n  }\n  .partnerspage__container__welcomdiv div:nth-child(1) {\n    font-size: 2.25vw;\n  }\n  .partnerspage__container__welcomdiv div:nth-child(2) div {\n    font-size: 1.75vw;\n  }\n  .partnerspage__container__support__div__card {\n    justify-content: space-around;\n  }\n  .partnerspage__container__support__div__card img {\n    width: 60px;\n    height: 60px;\n  }\n  .partnerspage__container__support__div__card__content div:nth-child(1) {\n    font-size: 1.75vw;\n  }\n  .partnerspage__container__support__div__card__content div:nth-child(2) {\n    font-size: 1.5vw;\n  }\n  .partnerspage__container__support__div__card__nextbtn__imgdiv img {\n    width: 20px;\n    height: 20px;\n  }\n  /* partners style */\n\n  /* shipping style */\n  .shipping__hero {\n    height: 45vh;\n  }\n  .shipping__hero__content__div__text {\n    width: 58%;\n  }\n  .shipping__hero__content__div__text__heading {\n    font-size: 4vw;\n  }\n  .shipping__hero__content__div__text__content__top,\n  .shipping__hero__content__div__text__content__bottom {\n    font-size: 1.75vw;\n  }\n  .shipping__hero__content__div__text__button button {\n    font-size: 1.75vw;\n  }\n  .shipping__hero__content__div__image {\n    width: 42%;\n  }\n  .shipping__container__toppart__heading {\n    font-size: 3vw;\n    letter-spacing: 0;\n  }\n  .shipping__container__toppart__box__content__div {\n    width: 45%;\n  }\n  .shipping__container__toppart__box__content__div__wrapper .heading {\n    font-size: 16px;\n  }\n  .shipping__container__toppart__box__content__div__wrapper .text {\n    font-size: 14px;\n  }\n  .shipping__container__toppart__box__content .bg {\n    top: 3%;\n  }\n  .shipping__container__support__div__card {\n    justify-content: space-around;\n  }\n  .shipping__container__support__div__card img {\n    width: 60px;\n    height: 60px;\n  }\n  .shipping__container__support__div__card__content div:nth-child(1) {\n    font-size: 1.75vw;\n  }\n  .shipping__container__support__div__card__content div:nth-child(2) {\n    font-size: 1.5vw;\n  }\n  .shipping__container__support__div__card__nextbtn__imgdiv img {\n    width: 20px;\n    height: 20px;\n  }\n  /* shipping style */\n}\n\n@media screen and (max-width: 580px) {\n  /* navbar */\n  .header__navbar {\n    height: 8vh;\n  }\n  .header_logo img {\n    width: 180px;\n  }\n  .webbie_container_container__navitems {\n    display: none;\n  }\n  .homepage__navbar__container__navitems_login {\n    display: none;\n  }\n  .homepage__navbar__hamburger {\n    display: block;\n    cursor: pointer;\n  }\n  .homepage__navbar__hamburger i {\n    font-size: 24px;\n  }\n  /*  navbar */\n\n  /* home style */\n  .homepage__navbar {\n    height: 8vh;\n  }\n  .homepage__navbar__container__logo img {\n    width: 180px;\n  }\n  .homepage__navbar__container__navitems {\n    display: none;\n  }\n  .homepage__navbar__container__navitems_login {\n    display: none;\n  }\n  .homepage__navbar__hamburger {\n    display: block;\n    cursor: pointer;\n  }\n  .homepage__navbar__hamburger i {\n    font-size: 24px;\n  }\n  .hero {\n    height: 50vh;\n    width: 100%;\n    background-image: url(\"/src/assets/images/images/home-hero-bg-mobile.png\");\n    background-size: cover;\n    object-position: 50% center; /* Centers the image horizontally and vertically */\n    background-repeat: no-repeat;\n  }\n  .hero__herosection__img1,\n  .hero__herosection__img2 {\n    position: static;\n    display: none;\n  }\n  .hero__content__div__text {\n    width: 100%;\n    text-align: center;\n    gap: 12px;\n  }\n  .hero__content__div__text__heading {\n    font-size: 24px;\n  }\n  .hero__content__div__text__content {\n    font-size: 15px;\n    font-weight: 300;\n    width: 97%;\n    margin: 0 auto;\n  }\n  .hero__content__div__text__button a {\n    font-size: 18px;\n    padding: 8px 12px;\n  }\n  .hero__content__div__image {\n    display: none;\n    width: 0px;\n  }\n  .homepage__bussinessbox__container {\n    width: 90%;\n    flex-direction: column;\n  }\n  .homepage__bussinessbox__container__img1,\n  .homepage__bussinessbox__container__img2,\n  .homepage__bussinessbox__container__img3 {\n    width: 100%;\n  }\n  .homepage__bussinessbox__container__img1__div,\n  .homepage__bussinessbox__container__img2__div,\n  .homepage__bussinessbox__container__img3__div {\n    width: 100%;\n  }\n\n  .homepage__bussinessbox__container__img1__div div,\n  .homepage__bussinessbox__container__img2__div div,\n  .homepage__bussinessbox__container__img3__div div {\n    font-size: 20px;\n  }\n  .homepage__bussinessbox__container__plus,\n  .homepage__bussinessbox__container__equal {\n    font-size: 96px;\n  }\n\n  .homepage__bussinessbox__container__text {\n    flex-direction: row;\n    width: fit-content;\n    max-width: 90%;\n    gap: 5px;\n    /* margin: 0 auto; */\n  }\n  .homepage__bussinessbox__container__text span {\n    font-size: 26px;\n  }\n\n  .homepage__bsimplified__container {\n    width: 90%;\n    padding: 0;\n    flex-direction: column;\n    gap: 20px;\n  }\n  .homepage__bsimplified__container__content {\n    width: 100%;\n  }\n  .homepage__bsimplified__container__content__heading {\n    font-size: 26px;\n    text-align: center;\n  }\n  .homepage__bsimplified__container__content__list {\n    gap: 20px;\n    padding-left: 20px;\n  }\n  .homepage__bsimplified__container__content__signupbtn {\n    justify-content: center;\n  }\n  .homepage__bsimplified__container__content__list li span {\n    font-size: 16px;\n  }\n  .homepage__bsimplified__container__content__signupbtn a span {\n    font-size: 20px;\n  }\n  .homepage__bsimplified__right {\n    width: 100%;\n  }\n  .homepage__bottomPart {\n    height: auto;\n    padding: 5vh 0;\n  }\n  .homepage__bottomPart__businessgrow {\n    flex-direction: column;\n    align-items: center;\n    gap: 4vmax;\n    width: 100%;\n  }\n  .homepage__bottomPart__businessgrow__image {\n    position: static;\n    width: 90%;\n    height: 50vh;\n    margin-bottom: 20px;\n  }\n  .homepage__bottomPart__businessgrow__image__topcontent {\n    gap: 7px;\n  }\n  .homepage__bottomPart__businessgrow__image__topcontent\n    div:nth-child(3)\n    span:nth-child(1) {\n    font-size: 20px;\n  }\n  .homepage__bottomPart__businessgrow__image__topcontent\n    div:nth-child(3)\n    span:nth-child(2) {\n    font-size: 14px;\n  }\n  .homepage__bottomPart__businessgrow__image__topcontent\n    div:nth-child(4)\n    button {\n    font-size: 18px;\n    padding: 6px 18px;\n  }\n  .homepage__bottomPart__businessgrow__image__topcontent div:nth-child(5) p {\n    font-size: 12px;\n  }\n  .homepage__bottomPart__businessgrow__right {\n    width: 90%;\n    position: static;\n    height: auto;\n    gap: 20px;\n  }\n  .homepage__bottomPart__businessgrow__right__content {\n    font-size: 26px;\n    text-align: center;\n  }\n\n  .homepage__partners__div {\n    width: 90%;\n  }\n  .homepage__partners__div__head {\n    text-align: center;\n  }\n  .homepage__partners__div__head span:nth-child(1),\n  .homepage__partners__div__head span:nth-child(3) {\n    display: none;\n  }\n  .homepage__partners__div__head span:nth-child(2) {\n    width: 100%;\n    font-size: 26px;\n  }\n  .slick-slide {\n    display: flex !important;\n    justify-content: center;\n    align-items: center;\n  }\n  /* .homepage__partners__div__brandlogos {\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n    gap: 30px;\n    padding-bottom: 10px;\n  } */\n  .homepage__partners__div__brandlogos__c1 {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    gap: 6%;\n  }\n  .homepage__partners__div__brandlogos__c1 div img {\n    width: 160px;\n    height: 35px;\n    object-fit: contain;\n  }\n  .homepage__partners__div__brandlogos__c1 div:nth-child(2) img,\n  .homepage__partners__div__brandlogos__c1 div:nth-child(3) img,\n  .homepage__partners__div__brandlogos__c1 div:nth-child(4) img {\n    width: 150px;\n    height: 35px;\n  }\n\n  .homepage__support__div {\n    width: 90%;\n    flex-direction: column;\n    gap: 30px;\n  }\n  .homepage__support__div__card {\n    width: 100%;\n    padding: 20px;\n    gap: 30px;\n  }\n  .homepage__support__div__card__image img {\n    width: 70px;\n    height: 70px;\n  }\n  .homepage__support__div__card__nextbtn__imgdiv {\n    padding: 6px 24px;\n    font-size: 16px;\n    border-radius: 20px;\n  }\n\n  .homepage__support__div__card__image .roundshape {\n    height: 30px;\n    width: 30px;\n    top: 22px;\n  }\n  .homepage__support__div__card__content div:nth-child(1) {\n    font-size: 20px;\n  }\n  .homepage__support__div__card__content div:nth-child(2) {\n    font-size: 14px;\n    font-weight: 300;\n  }\n  .homepage__footer__div__top__aboutus div:nth-child(1) {\n    font-size: 2vw;\n  }\n  .homepage__footer__div__top__aboutus div:nth-child(2) {\n    font-size: 2vw;\n  }\n  .homepage__footer__div__top__right__notifications {\n    font-size: 2vw;\n  }\n  .homepage__footer__div__top__right__notifications li a {\n    font-size: 2vw;\n  }\n  .homepage__footer__div__top__right__form {\n    width: 60%;\n  }\n  .homepage__footer__div__top__right__form button {\n    font-size: 2vw;\n  }\n  .homepage__footer__div__bottom__left span {\n    font-size: 1.5vw;\n  }\n  .homepage__footer__div__bottom__left span a {\n    font-size: 1.5vw;\n  }\n  .homepage__footer__div__bottom__right {\n    font-size: 1.5vw;\n  }\n  /* home style */\n\n  /* about style */\n  .aboutpage__container {\n    width: 90%;\n  }\n  .aboutpage__container__div__para p {\n    font-size: 14px;\n  }\n  .aboutpage__container__trustdiv {\n    flex-direction: column;\n    gap: 20px;\n  }\n  .aboutpage__container__trustdiv__left {\n    width: 100%;\n    padding: 12px 16px;\n  }\n  .aboutpage__container__trustdiv__left__title {\n    font-size: 20px;\n  }\n  .aboutpage__container__trustdiv__left__images__top {\n    justify-content: space-between;\n  }\n  .aboutpage__container__trustdiv__left__images__top div {\n    width: 45%;\n  }\n  .aboutpage__container__trustdiv__right {\n    width: 100%;\n    padding: 12px 16px;\n    gap: 32px;\n  }\n  .aboutpage__container__trustdiv__right div {\n    font-size: 20px;\n  }\n  .aboutpage__container__trustdiv__right__nextbtn__imgdiv {\n    width: 35px;\n    height: 35px;\n  }\n  .aboutpage__container__trustdiv__right__nextbtn__imgdiv img {\n    width: 25px;\n  }\n  .aboutpage__container__welcomediv {\n    width: 90%;\n  }\n  .aboutpage__container__welcomediv div:nth-child(1) {\n    font-size: 20px;\n  }\n  .aboutpage__container__welcomediv div:nth-child(2) {\n    flex-direction: column;\n    gap: 10px;\n  }\n  .aboutpage__container__welcomediv div:nth-child(2) div {\n    width: 100%;\n  }\n\n  /* about style */\n\n  /* contact style */\n\n  .contactuspage__container {\n    width: 90%;\n  }\n  .contactuspage__container__div__para__form__container {\n    width: 100%;\n  }\n  .contactuspage__container__div__para__form__container .heading {\n    font-size: 20px;\n  }\n  .contact__form {\n    gap: 20px;\n  }\n  .contact__form__inputfield {\n    width: 100%;\n  }\n  .contact__form__label {\n    font-size: 14px;\n  }\n  .contact__form__inputfield input,\n  select {\n    font-size: 14px;\n  }\n  .contact__form__inputfield select {\n    font-size: 14px;\n  }\n\n  .contact__form__inputfield input::placeholder {\n    font-size: 14px;\n  }\n  .contact__form__contactemail {\n    flex-direction: column;\n    width: 100%;\n    gap: 20px;\n  }\n  .contact__form__contactemail div {\n    width: 100%;\n    gap: 12px;\n  }\n  #contact__form__inputfield__button {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n  }\n  .contact__form__button__submit {\n    font-size: 16px;\n    padding: 8px 16px;\n    margin: 0;\n  }\n  .contactuspage__container__trustdiv__right__nextbtn__imgdiv {\n    width: 25px;\n    height: 25px;\n  }\n  .contactuspage__container__trustdiv__right__nextbtn__imgdiv img {\n    width: 20px;\n    height: 20px;\n  }\n  .contactuspage__container__welcomediv__title span:nth-child(1),\n  .contactuspage__container__welcomediv__title span:nth-child(3) {\n    display: none;\n  }\n  .contactuspage__container__welcomediv__title {\n    width: 100%;\n    font-size: 20px;\n    justify-content: center;\n  }\n  .contactuspage__container__welcomediv__div1,\n  .contactuspage__container__welcomediv__div2 {\n    flex-direction: column;\n    gap: 20px;\n  }\n\n  .contactuspage__container__welcomediv__div1 div,\n  .contactuspage__container__welcomediv__div2 div {\n    width: 100%;\n  }\n  /* contact style */\n\n  /* payment style */\n  .payments__container,\n  .shipping__container {\n    width: 90%;\n  }\n  .payments__container__partners {\n    padding: 0;\n  }\n  .payments__container__partners__div__head span:nth-child(1),\n  .payments__container__partners__div__head span:nth-child(3) {\n    display: none;\n  }\n  .payments__container__partners__div__head span:nth-child(2) {\n    width: 100%;\n    font-size: 26px;\n  }\n  .payments__container__partners__div__brandlogos {\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n    gap: 25px;\n  }\n  .payments__container__partners__div__brandlogos div {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n  }\n  .payments__container__partners__div__brandlogos div img {\n    width: 200px;\n    height: 40px;\n    object-fit: contain;\n  }\n  .payments__container__partners__div__brandlogos div:nth-child(2) img,\n  .payments__container__partners__div__brandlogos div:nth-child(3) img,\n  .payments__container__partners__div__brandlogos div:nth-child(4) img {\n    width: 186px;\n    height: 35px;\n  }\n\n  .payments__container__toppart__heading {\n    font-size: 20px;\n    text-align: center;\n  }\n  .payments__container__toppart__box__content__div__wrapper {\n    left: 8px;\n  }\n  .payments__container__toppart__box__content__div__wrapper .heading {\n    font-size: 16px;\n  }\n  .payments__container__toppart__box__content__div__wrapper .text {\n    padding-top: 20px;\n    font-size: 13px;\n  }\n  .payments__container__toppart__box__content {\n    flex-direction: column;\n    gap: 70px;\n  }\n  .payments__container__toppart__box__content__div {\n    height: 200px;\n    min-height: 200px;\n    width: 100%;\n  }\n  .payments__container__toppart__box__content__div__wrapper {\n    height: 200px;\n    min-height: 200px;\n  }\n  .payments__container__toppart__box__content__div .bg {\n    height: 250px;\n    min-height: 250px;\n    top: 3%;\n    left: -1px;\n  }\n  .payments__container__partners__div__button {\n    margin-top: 6vh;\n  }\n  .payments__container__partners__div__button a {\n    font-size: 16px;\n    padding: 8px 16px;\n    border-radius: 6px;\n  }\n\n  /* payment style */\n\n  /* partners style */\n  .partnerspage__hero {\n    height: 50vh;\n    width: 100%;\n    text-align: center;\n  }\n  .partnerspage__hero__content__div__left {\n    width: 100%;\n  }\n  .partnerspage__hero__content__div__left__text {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n  }\n  .partnerspage__hero__content__div__text {\n    width: 100%;\n  }\n  .partnerspage__hero__content__div__left__text__heading {\n    font-size: 24px;\n  }\n  .partnerspage__hero__content__div__left__text__content {\n    width: 100%;\n    gap: 20px;\n  }\n  .partnerspage__hero__content__div__left__text__content__top {\n    font-size: 15px;\n    font-weight: 300;\n    width: 100%;\n    margin: 0 auto;\n  }\n  .partnerspage__hero__content__div__left__text {\n    padding: 0;\n  }\n  .partnerspage__hero__content__div__left__text__button a {\n    font-size: 18px;\n    padding: 8px 12px;\n  }\n  .partnerspage__hero__content__div__image {\n    display: none;\n  }\n\n  .partnerspage__container__trustdiv__right__nextbtn__imgdiv {\n    width: 25px;\n    height: 25px;\n  }\n  .partnerspage__container__trustdiv__right__nextbtn__imgdiv img {\n    width: 20px;\n    height: 20px;\n  }\n  .partnerspage__container__div__para {\n    flex-direction: column;\n  }\n  .partnerspage__container__div__para__box {\n    width: 100%;\n  }\n  .partnerspage__container__div__para__equal {\n    font-size: 96px;\n  }\n  .partnerspage__container__welcomediv__title {\n    width: 90%;\n    font-size: 20px;\n    justify-content: center;\n  }\n  .partnerspage__container__welcomediv__title span:nth-child(1),\n  .partnerspage__container__welcomediv__title span:nth-child(3) {\n    display: none;\n  }\n  .partnerspage__container__welcomediv__div1,\n  .partnerspage__container__welcomediv__div2 {\n    flex-direction: column;\n    gap: 20px;\n  }\n  .partnerspage__container__welcomediv__div1 div,\n  .partnerspage__container__welcomediv__div2 div {\n    width: 100%;\n    font-size: 16px;\n  }\n\n  /* partners style */\n\n  /* shipping style */\n  .shipping__container__toppart__heading {\n    font-size: 20px;\n    text-align: center;\n  }\n  .shipping__container__toppart__box__content__div__wrapper .heading {\n    font-size: 20px;\n    font-weight: 700;\n  }\n  .shipping__container__toppart__box__content__div__wrapper .text {\n    font-size: 16px;\n  }\n  .shipping__container__toppart__box__content {\n    flex-direction: column;\n    gap: 40px;\n  }\n  .shipping__container__toppart__box__content__div {\n    height: 200px;\n    min-height: 200px;\n    width: 100%;\n  }\n  .shipping__container__toppart__box__content__div__wrapper {\n    height: 200px;\n    min-height: 200px;\n  }\n  .shipping__container__toppart__box__content__div .bg {\n    height: 200px;\n    min-height: 200px;\n    top: 7%;\n  }\n  /* shipping style */\n\n  /* footer style */\n  .footer__div__top {\n    flex-direction: column;\n    gap: 20px;\n  }\n  .footer__div__top__aboutus {\n    width: 100%;\n  }\n  .footer__div__top__aboutus div:nth-child(1) {\n    font-size: 16px;\n  }\n  .footer__div__top__aboutus div:nth-child(2) {\n    font-size: 14px;\n  }\n  .footer__div__top__aboutus div:nth-child(3) {\n    font-size: 20px;\n    padding: 4px 0;\n  }\n  .footer__div__top__right__notifications__heading {\n    font-size: 16px;\n  }\n\n  .footer__div__top__right {\n    flex-direction: column;\n    gap: 20px;\n    width: 100%;\n    padding-left: 0;\n  }\n  .footer__div__top__right__notifications {\n    font-size: 2vw;\n    width: 100%;\n  }\n  .footer__div__top__right__notifications li a {\n    font-size: 14px;\n  }\n  .footer__div__top__right__form {\n    width: 100%;\n  }\n  .footer__div__top__right__form input {\n    width: 90%;\n    padding: 10px;\n    border-radius: 5px;\n  }\n  .footer__div__top__right__form button {\n    font-size: 16px;\n    width: fit-content;\n    padding: 8px 32px;\n    border-radius: 5px;\n  }\n  .footer__div__bottom {\n    flex-direction: column;\n    gap: 20px;\n  }\n  .footer__div__bottom__left span {\n    font-size: 13px;\n  }\n  .footer__div__bottom__left span a {\n    font-size: 13px;\n  }\n  .footer__div__bottom__right {\n    font-size: 13px;\n  }\n  /* footer style */\n\n  /* Pricing Style */\n  .pricing__container__heading {\n    font-size: 20px;\n  }\n  .pricing__container__content {\n    font-size: 14px;\n  }\n  .pricing__container__subscribe__card__content .heading {\n    font-size: 20px;\n  }\n  .pricing__container__subscribe {\n    flex-direction: column;\n    gap: 20px;\n  }\n  .pricing__container__subscribe__card {\n    padding: 20px 0 40px;\n    width: 100%;\n  }\n  .pricing__container__subscribe__card__content .buttondiv button {\n    font-size: 18px;\n    padding: 8px 16px;\n  }\n  /* pricing style */\n}\n@media (min-width: 360px) and (max-width: 580px) {\n  .payments__container__toppart__heading,\n  .shipping__container__toppart__heading {\n    font-size: 15px;\n    text-align: center;\n  }\n  .overlay-wrapper .subscription-card .statement {\n    font-size: 1rem !important;\n    text-align: center;\n  }\n}\n@media (max-width: 1438px) {\n  lottie-player {\n    width: 300px !important;\n  }\n}\n\n@media (max-width: 1124px) {\n  #animation-container {\n    display: none;\n  }\n}\n\n.slider--all-heading {\n  color: #ffffff;\n  font-size: var(--hero-font);\n  font-weight: 1000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
